import { MemberSidebarItem } from '../models/MemberSidebarItem';
import { SidebarItem } from '../models/SidebarItem';
import { ClientAccount } from '../models/UserMetadata';
import { StorageService } from '../services/storage/storage.service';

export class Constants {
  public static getCurrentClientPathKey(): string {
    const storageService: StorageService = new StorageService();
    const currentClient: ClientAccount = storageService.getItem('current_client');
    return currentClient?.path_key ?? '';
  }

  public static readonly FITTERFLY_PATH_KEY: string = 'fitterfly';
  public static readonly ABHI_PATH_KEY: string = 'abhi';
  public static readonly STAR_HEALTH_PATH_KEY: string = 'star-health';
  public static readonly NOVITAS_PATH_KEY: string = 'novitas';

  public static readonly SUCCESS: string = 'success';
  public static readonly INFO: string = 'info';
  public static readonly ERROR: string = 'error';
  public static readonly WARN: string = 'warn';
  public static readonly PAGE: number = 1;
  public static readonly PER_PAGE: number = 10;
  public static readonly EDIT: string = 'edit';
  public static readonly ADD: string = 'add';
  public static readonly UPDATE: string = 'update';
  public static readonly COPY: string = 'copy';
  public static readonly ERROR_CAPS: string = 'Error';
  public static readonly SUCCESS_CAPS: string = 'Success';
  public static readonly INFO_CAPS: string = 'Information';
  public static readonly WARN_CAPS: string = 'Warning';
  public static readonly PRIMARY_BUTTON_TEXT_COLOR: string = '#fff';
  public static readonly TIMEZONE: string = 'Asia/Kolkata';
  public static readonly ROWS: number[] = [1, 2, 3, 4, 5, 6, 7, 8];
  public static readonly JEDI: string = 'JEDI';

  /* Coach working hours set on Admin is 8:00 AM to 8:00 PM */
  public static readonly COACH_PREFERRED_START_TIME: Date = new Date(new Date().setHours(8, 0, 0, 0));
  public static readonly COACH_PREFERRED_END_TIME: Date = new Date(new Date().setHours(20, 0, 0, 0));

  public static readonly PARTICIPATION_STATUS_CLASS_NAME: string = 'participation-s';
  public static readonly SENSOR_DAY_CLASS_NAME: string = 'sensor-day-s';
  public static readonly TASK_STATUS_CLASS_NAME: string = 'task-s';
  public static readonly LEAD_STATUS_CLASS_NAME: string = 'lead-s';
  public static readonly SESSION_STATUS_CLASS_NAME: string = 'session-s';
  public static readonly COHORT_STATUS_CLASS_NAME: string = 'cohort-s';
  public static readonly OVERVIEW_LABELS_CLASS_NAME: string = 'overview-labels-s';
  public static readonly SUPPORT_TICKET_CLASS_NAME: string = 'support-ticket-s';

  public static readonly NEW_ASSESSMENT: string = 'assessment-new';
  public static readonly NEW_REPORT: string = 'report-new';
  public static readonly EDIT_ASSESSMENT: string = 'assessment-edit';
  public static readonly EDIT_REPORT: string = 'report-edit';
  public static readonly PPT_PLAN: string = 'ppt_physiotherapy_plan';
  public static readonly PPL_PLAN: string = 'ppl_psycology_plan';
  public static readonly SET_CARE_TEAM_TYPE: string = 'set-care-team';
  public static readonly UPDATE_CARE_TEAM_TYPE: string = 'update-care-team';
  public static readonly FTX_CV_SCORE_REPORT: string = 'cv_score';

  public static readonly URL_REGEX =
    /(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/;

  public static readonly MALE: number = 1;
  public static readonly FEMALE: number = 2;
  public static readonly OTHERS: number = 3;

  public static readonly GENDERS: any = {
    1: {
      id: 1,
      name: 'Male',
    },
    2: {
      id: 2,
      name: 'Female',
    },
    3: {
      id: 3,
      name: 'Other',
    },
  };

  public static readonly SPECIALTIY_OF_DOCTORS: any = {
    Physician: {
      name: 'Physician',
      value: 'Physician',
    },
    Diabetologist: {
      name: 'Diabetologist',
      value: 'Diabetologist',
    },
    Endocrinologist: {
      name: 'Endocrinologist',
      value: 'Endocrinologist',
    },
    Cardiologist: {
      name: 'Cardiologist',
      value: 'Cardiologist',
    },
    Nephrologist: {
      name: 'Nephrologist',
      value: 'Nephrologist',
    },
    Gynaecologist: {
      name: 'Gynaecologist',
      value: 'Gynaecologist',
    },
    IVFSpecialist: {
      name: 'IVFSpecialist',
      value: 'IVFSpecialist',
    },
  };

  /* All Roles */
  public static readonly CARE_MANAGER_ROLE: string = 'CM';
  public static readonly CARE_MANAGER_TEAM_LEAD_ROLE: string = 'CM_TL';
  public static readonly NUTRITION_COACH_ROLE: string = 'PC';
  public static readonly NUTRITION_COACH_TEAM_LEAD_ROLE: string = 'TL';
  public static readonly PSYCHOLOGIST_COACH_ROLE: string = 'PPL';
  public static readonly PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE: string = 'PPL_TL';
  public static readonly PHYSIOTHERAPIST_COACH_ROLE: string = 'PPT';
  public static readonly PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE: string = 'PPT_TL';
  public static readonly PRIMARY_OPERATION_MANAGER_ROLE: string = 'POM';
  public static readonly SECONDARY_OPERATION_MANAGER_ROLE: string = 'SOM';
  public static readonly PROGRAM_ADVISOR_ROLE: string = 'CSE';
  public static readonly PROGRAM_ADVISOR_CALLER_ACCESS_ROLE: string = 'CSECA';
  public static readonly PROGRAM_ADVISOR_TEAM_LEAD_ROLE: string = 'CSETL';
  public static readonly QC_MANAGER_ROLE: string = 'QCM';
  public static readonly PHLEBOTOMIST_ROLE: string = 'PLB';
  public static readonly EVENT_ADMIN_ROLE: string = 'EA';
  public static readonly SESSION_INCHARGE_ROLE: string = 'SIC';
  public static readonly OPS_SUPPORT: string = 'ops_support';
  public static readonly DOCTOR_ROLE: string = 'DR';
  public static readonly MANAGE_ADMINS: string = 'allow_manage_admins';
  public static readonly ONBOARDING_AGENT_ROLE: string = 'OA';
  public static readonly ONBOARDING_AGENT_LEAD_ROLE: string = 'OA_TL';
  public static readonly PROGRAM_CO_ORDINATOR: string = 'PCO';
  public static readonly ONBOARDING_COACH_ROLE: string = 'OC';

  // * Team leads list.
  public static readonly LEAD_ROLES: string[] = [
    Constants.CARE_MANAGER_TEAM_LEAD_ROLE,
    Constants.NUTRITION_COACH_TEAM_LEAD_ROLE,
    Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE,
    Constants.PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE,
    Constants.ONBOARDING_AGENT_LEAD_ROLE,
    Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE
  ];

  // * Team leads and there respective team member role.
  public static readonly TEAM_LEAD_TO_TEAM_MEMBER_MAPPING: { [key: string]: string } = {
    [Constants.CARE_MANAGER_TEAM_LEAD_ROLE]: Constants.CARE_MANAGER_ROLE,
    [Constants.NUTRITION_COACH_TEAM_LEAD_ROLE]: Constants.NUTRITION_COACH_ROLE,
    [Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE]: Constants.PSYCHOLOGIST_COACH_ROLE,
    [Constants.PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE]: Constants.PHYSIOTHERAPIST_COACH_ROLE,
    [Constants.ONBOARDING_AGENT_LEAD_ROLE]: Constants.ONBOARDING_AGENT_ROLE,
    [Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE]: Constants.PROGRAM_ADVISOR_ROLE,
  };

  public static readonly ALL_ROLES: string[] = [
    Constants.CARE_MANAGER_ROLE,
    Constants.CARE_MANAGER_TEAM_LEAD_ROLE,
    Constants.NUTRITION_COACH_ROLE,
    Constants.NUTRITION_COACH_TEAM_LEAD_ROLE,
    Constants.PSYCHOLOGIST_COACH_ROLE,
    Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE,
    Constants.PHYSIOTHERAPIST_COACH_ROLE,
    Constants.PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE,
    Constants.PRIMARY_OPERATION_MANAGER_ROLE,
    Constants.SECONDARY_OPERATION_MANAGER_ROLE,
    Constants.QC_MANAGER_ROLE,
    Constants.PHLEBOTOMIST_ROLE,
    Constants.DOCTOR_ROLE
  ];

  /* First Level Sidebar */
  public static readonly MAIN_COACH_OVERVIEW_ROUTE: string = 'overview';
  public static readonly MAIN_TASKS_ROUTE: string = 'tasks';
  public static readonly MAIN_MEMBERS_ROUTE: string = 'members';
  public static readonly MAIN_REFERRALS_ROUTE: string = 'referrals';
  public static MAIN_MEMBER_DETAILS_ROUTE: string = `member-details/${this.getCurrentClientPathKey()}`;
  public static readonly MAIN_CAMPAIGN_REPORTS: string = 'campaign-reports';
  public static readonly MAIN_OPPORTUNITY_FILTER: string = 'opportunity-list';
  public static readonly MAIN_INVOICE_MASTER: string = 'invoice-master';
  public static readonly MAIN_CSE_ACCOUNT_SETTINGS: string = 'cse-account-settings';
  public static readonly MAIN_LSQ_MAPPING: string = 'lsq-mapping';
  public static readonly MAIN_OPPORTUNITY_DETAIL: string = 'opportunity-detail';
  public static readonly MAIN_LEAD_DETAIL: string = 'lead-detail';
  public static readonly MAIN_LEAD_LIST: string = 'lead-list';
  public static readonly MAIN_EVENT_ADMIN_ROUTE: string = 'event-admin';
  public static readonly MAIN_SESSION_IN_CHARGE_ROUTE: string = 'sessions-cohorts';
  public static readonly INVOICE_DETAILS: string = 'details';
  public static readonly INVOICE_ADD: string = 'add-invoice';
  public static readonly AUDIT_TRAIL: string = 'audit-trail';
  public static readonly SUPPORT: string = 'support';
  public static readonly MAIN_CHAT_ROUTE: string = 'chat';
  public static readonly MAIN_NOTIFICATION_ROUTE: string = 'notification';
  public static readonly MAIN_INTERNAL_SUPPORT_ROUTE: string = 'internal-support';
  public static readonly LEAD_PATIENT_SEARCH_ROUTE: string = 'lead-patient-search';
  public static readonly MAIN_MSE_ACCOUNT_SETTINGS: string = 'mse-account-settings';
  public static readonly MAIN_SUPPORT_TICKETING_SYSTEM_ROUTE: string = 'support-tickets';
  public static readonly ADMIN_LIST: string = 'admins';
  public static readonly MAIN_IVR_RECORDINGS_ROUTE: string = 'ivr-recordings';
  public static readonly CLIENT_ROUTE: string = 'client';
  public static readonly MAIN_UPSELL_ROUTE: string = 'upsell';

  public static readonly SIDEBAR_ITEMS: SidebarItem[] = [
    {
      navId: 1,
      navTitle: 'Overview',
      navUrl: Constants.MAIN_COACH_OVERVIEW_ROUTE,
      navIconClass: 'icon-nav-overview-inactive',
      navIconActiveClass: 'icon-nav-overview-active',
      visibleFor: [...Constants.ALL_ROLES, Constants.ONBOARDING_AGENT_LEAD_ROLE, Constants.ONBOARDING_AGENT_ROLE, Constants.ONBOARDING_COACH_ROLE],
      restrictedClients: []
    },
    {
      navId: 2,
      navTitle: 'Tasks',
      navUrl: Constants.MAIN_TASKS_ROUTE,
      navIconClass: 'icon-nav-tasks-inactive',
      navIconActiveClass: 'icon-nav-tasks-active',
      visibleFor: [...Constants.ALL_ROLES, Constants.ONBOARDING_AGENT_LEAD_ROLE, Constants.ONBOARDING_AGENT_ROLE, Constants.ONBOARDING_COACH_ROLE],
      restrictedClients: []
    },
    {
      navId: 3,
      navTitle: 'Members',
      navUrl: Constants.MAIN_MEMBERS_ROUTE,
      navIconClass: 'icon-nav-members-inactive',
      navIconActiveClass: 'icon-nav-members-active',
      visibleFor: [...Constants.ALL_ROLES, Constants.PROGRAM_ADVISOR_ROLE, Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE, Constants.PROGRAM_ADVISOR_CALLER_ACCESS_ROLE, Constants.ONBOARDING_COACH_ROLE],
      restrictedClients: []
    },
    {
      navId: 4,
      navTitle: 'Lead List',
      navUrl: Constants.MAIN_LEAD_LIST,
      navIconClass: 'icon-nav-lead-list-inactive',
      navIconActiveClass: 'icon-nav-lead-list-active',
      visibleFor: [
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.PROGRAM_ADVISOR_CALLER_ACCESS_ROLE,
        Constants.PROGRAM_ADVISOR_ROLE,
      ],
      restrictedClients: []
    },
    {
      navId: 5,
      navTitle: 'Chats',
      navUrl: Constants.MAIN_CHAT_ROUTE,
      navIconClass: 'icon-nav-chats-inactive',
      navIconActiveClass: 'icon-nav-chats-active',
      visibleFor: [Constants.NUTRITION_COACH_TEAM_LEAD_ROLE, Constants.NUTRITION_COACH_ROLE],
      restrictedClients: []
    },
    {
      navId: 6,
      navTitle: 'Referrals',
      navUrl: Constants.MAIN_REFERRALS_ROUTE,
      navIconClass: 'icon-nav-referrals-inactive',
      navIconActiveClass: 'icon-nav-referrals-active',
      visibleFor: Constants.ALL_ROLES,
      restrictedClients: []
    },
    {
      navId: 8,
      navTitle: 'Invoice Master',
      navUrl: Constants.MAIN_INVOICE_MASTER,
      navIconClass: 'icon-nav-invoice-master-inactive',
      navIconActiveClass: 'icon-nav-invoice-master-active',
      visibleFor: [
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.PROGRAM_ADVISOR_CALLER_ACCESS_ROLE,
        Constants.PROGRAM_ADVISOR_ROLE,
      ],
      restrictedClients: []
    },
    {
      navId: 9,
      navTitle: 'Audit Trail',
      navUrl: Constants.AUDIT_TRAIL,
      navIconClass: 'icon-nav-audit-trail-inactive',
      navIconActiveClass: 'icon-nav-audit-trail-active',
      visibleFor: [
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.OPS_SUPPORT,
      ],
      restrictedClients: []
    },
    {
      navId: 10,
      navTitle: 'Campaign Reports',
      navUrl: Constants.MAIN_CAMPAIGN_REPORTS,
      navIconClass: 'icon-nav-campaign-reports-inactive',
      navIconActiveClass: 'icon-nav-campaign-reports-active',
      visibleFor: [
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.PROGRAM_ADVISOR_CALLER_ACCESS_ROLE,
        Constants.PROGRAM_ADVISOR_ROLE,
      ],
      restrictedClients: []
    },
    {
      navId: 11,
      navTitle: 'CSE Account Settings',
      navUrl: Constants.MAIN_CSE_ACCOUNT_SETTINGS,
      navIconClass: 'icon-nav-cse-acc-settings-inactive',
      navIconActiveClass: 'icon-nav-cse-acc-settings-active',
      visibleFor: [
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.PROGRAM_ADVISOR_CALLER_ACCESS_ROLE,
      ],
      restrictedClients: []
    },
    {
      navId: 12,
      navTitle: 'LSQ Mapping',
      navUrl: Constants.MAIN_LSQ_MAPPING,
      navIconClass: 'icon-nav-lsq-mapping-inactive',
      navIconActiveClass: 'icon-nav-lsq-mapping-active',
      visibleFor: [
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.PROGRAM_ADVISOR_CALLER_ACCESS_ROLE,
        Constants.PROGRAM_ADVISOR_ROLE,
      ],
      restrictedClients: []
    },
    {
      navId: 14,
      navTitle: 'Event Admin',
      navUrl: Constants.MAIN_EVENT_ADMIN_ROUTE,
      navIconClass: 'icon-nav-event-admin-inactive',
      navIconActiveClass: 'icon-nav-event-admin-active',
      visibleFor: [Constants.EVENT_ADMIN_ROLE],
      restrictedClients: []
    },
    {
      navId: 15,
      navTitle: 'Sessions & Cohorts',
      navUrl: Constants.MAIN_SESSION_IN_CHARGE_ROUTE,
      navIconClass: 'icon-nav-sic-inactive',
      navIconActiveClass: 'icon-nav-sic-active',
      visibleFor: [Constants.SESSION_INCHARGE_ROLE],
      restrictedClients: []
    },
    {
      navId: 16,
      navTitle: 'Backend Support',
      navUrl: Constants.SUPPORT,
      navIconClass: 'icon-nav-support-inactive',
      navIconActiveClass: 'icon-nav-support-active',
      visibleFor: [Constants.OPS_SUPPORT],
      restrictedClients: []
    },
    {
      navId: 17,
      navTitle: 'MSE Account Settings',
      navUrl: Constants.MAIN_MSE_ACCOUNT_SETTINGS,
      navIconClass: 'icon-nav-mse-acc-settings-inactive',
      navIconActiveClass: 'icon-nav-mse-acc-settings-active',
      visibleFor: [Constants.CARE_MANAGER_TEAM_LEAD_ROLE],
      restrictedClients: []
    },
    {
      navId: 18,
      navTitle: 'Notifications',
      navUrl: Constants.MAIN_NOTIFICATION_ROUTE,
      navIconClass: 'icon-nav-notification-inactive',
      navIconActiveClass: 'icon-nav-notification-active',
      visibleFor: [Constants.NUTRITION_COACH_ROLE, Constants.PHYSIOTHERAPIST_COACH_ROLE, Constants.PSYCHOLOGIST_COACH_ROLE, Constants.PROGRAM_ADVISOR_ROLE, Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE],
      restrictedClients: []
    },
    {
      navId: 19,
      navTitle: 'Support Tickets',
      navUrl: Constants.MAIN_SUPPORT_TICKETING_SYSTEM_ROUTE,
      navIconClass: 'icon-nav-ticketing-system-inactive',
      navIconActiveClass: 'icon-nav-ticketing-system-active',
      visibleFor: [...Constants.ALL_ROLES, Constants.EVENT_ADMIN_ROLE, Constants.SESSION_INCHARGE_ROLE],
      restrictedClients: []
    },
    {
      navId: 20,
      navTitle: 'Admins',
      navUrl: Constants.ADMIN_LIST,
      navIconClass: 'icon-nav-admin-list-inactive',
      navIconActiveClass: 'icon-nav-admin-list-active',
      visibleFor: [Constants.MANAGE_ADMINS],
      restrictedClients: [Constants.ABHI_PATH_KEY, Constants.NOVITAS_PATH_KEY, Constants.STAR_HEALTH_PATH_KEY]
    },
    {
      navId: 21,
      navTitle: 'IVR Recordings',
      navUrl: Constants.MAIN_IVR_RECORDINGS_ROUTE,
      navIconClass: 'icon-nav-ivr-recordings-inactive',
      navIconActiveClass: 'icon-nav-ivr-recordings-active',
      visibleFor: [Constants.ONBOARDING_AGENT_LEAD_ROLE, Constants.CARE_MANAGER_TEAM_LEAD_ROLE],
      restrictedClients: []
    },
    {
      navId: 22,
      navTitle: 'Upsell',
      navUrl: Constants.MAIN_UPSELL_ROUTE,
      navIconClass: 'icon-nav-member-upsell-crosssell',
      navIconActiveClass: 'icon-nav-member-upsell-crosssell-active',
      visibleFor: Constants.ALL_ROLES,
      restrictedClients: []
    }
    // ! Routes added here are picked up by ALL_MAIN_ROUTES automatically.
    // ! Only add a route to ALL_MAIN_ROUTES directly if it has no sidebar item.
  ];

  // * Routes allowed by mainRouteGuard. Built from SIDEBAR_ITEMS so role/client access is configured in one place.
  public static readonly ALL_MAIN_ROUTES: { route: string, visibleTo: string[], restrictedClients: string[] }[] = [
    ...Constants.SIDEBAR_ITEMS.map((si: SidebarItem) => ({
      route: si.navUrl,
      visibleTo: si.visibleFor,
      restrictedClients: si.restrictedClients,
    })),
    // ! Main routes without a sidebar item go below
    {
      route: Constants.MAIN_LEAD_DETAIL,
      visibleTo: [
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.PROGRAM_ADVISOR_CALLER_ACCESS_ROLE,
        Constants.PROGRAM_ADVISOR_ROLE,
        Constants.ONBOARDING_AGENT_ROLE,
        Constants.ONBOARDING_AGENT_LEAD_ROLE,
      ],
      restrictedClients: []
    },
    {
      route: Constants.MAIN_INTERNAL_SUPPORT_ROUTE,
      visibleTo: Constants.ALL_ROLES,
      restrictedClients: []
    },
  ];

  /* Sidebar items the given role can see for the given client (defaults to the current client) */
  public static getAccessibleSidebarItems(role: string, clientPathKey: string = Constants.getCurrentClientPathKey()): SidebarItem[] {
    return Constants.SIDEBAR_ITEMS.filter((si: SidebarItem) => si.visibleFor.includes(role) && !si.restrictedClients.includes(clientPathKey));
  }

  /* this should be the first route from SIDEBAR_ITEMS */
  public static DEFAULT_ROUTE: string = Constants.SIDEBAR_ITEMS[0].navUrl;

  public static readonly TOOLBAR: any = {
    placeholder: 'Enter text here...',
    tabsize: 2,
    height: '200px',
    backgroundColor: 'white',
    uploadImagePath: '/api/upload',
    disableResizeEditor: true,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear',
        ],
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']],
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
    ],
  };

  /* Members */
  public static readonly MEMBERS_COLUMNS: string[] = [
    'Member Name',
    'Program Name',
    'Package Name',
    'Start Day (APD)',
    'Status',
    'Sensor Details',
    'Sensor Day',
    'Campaign',
    'Referred by Doctor',
  ];

  public static readonly MEMBER_TYPES: any = {
    Test: {
      is_test: true,
      name: 'Test',
    },
    Actual: {
      is_test: false,
      name: 'Actual',
    },
  };

  public static readonly ADD_ON_CONSULTATION_TYPES: any[] = [
    { key: 'fitness_consultation', name: 'Fitness Management Session' },
    { key: 'pain_consultation', name: 'Pain Management Session' },
    { key: 'psychology_consultation', name: 'Psychology Consultation' },
    { key: 'doctor_consultation', name: 'Doctor Consultation' },
    { key: 'nutrition_consultation', name: 'Nutrition Consultation'},
  ];

  /* Tasks */
  public static readonly TASKS_COLUMNS: string[] = [
    '',
    'Member Name',
    'Remind on',
    'Status',
    'Actions',
  ];

  public static readonly TASKS_COLUMNS_FOR_CARE_TEAM: any[] = [
    {
      name: 'Member Name',
      width: '335px',
    },
    {
      name: 'Enrolled Program',
      width: '250px',
    },
    {
      name: 'Consented On',
      width: '250px',
    },
    {
      name: 'Preferred Start Date',
      width: '200px',
    },
    {
      name: 'Started On',
      width: '200px',
    },
    {
      name: 'Actions',
      width: '150px',
    },
  ];

  public static readonly TASKS_TABS: any[] = [
    { label: 'Appointments' },
    { label: 'Activities' },
  ];

  public static readonly FTX_CONTENT_TYPE: any = {
    SUB_TASK: 1,
    CONTENT: 2,
  };

  public static readonly FTX_PATIENT_COUNTRY_CODE: any = {
    INDIA: '+91',
    USA: '+1',
    UK: '+44',
    SINGAPORE: '+',
    UNITED_ARAB_EMIRATES: '+971',
    AUSTRALIA: '+61',
    NETHERLANDS: '+31',
    HUNGARY: '+36',
  };

  public static readonly PBH_SELF_RELATION_ID: string = '11';

  // PBH relationMaster; gender is used to prefill the member's gender.
  public static readonly PBH_RELATIONS: { id: string; name: string; gender: string | null }[] = [
    { id: '1', name: 'Father', gender: 'MALE' },
    { id: '2', name: 'Mother', gender: 'FEMALE' },
    { id: '3', name: 'Son', gender: 'MALE' },
    { id: '4', name: 'Daughter', gender: 'FEMALE' },
    { id: '5', name: 'Brother', gender: 'MALE' },
    { id: '6', name: 'Sister', gender: 'FEMALE' },
    { id: '9', name: 'Husband', gender: 'MALE' },
    { id: '10', name: 'Wife', gender: 'FEMALE' },
    { id: '11', name: 'Self', gender: null },
  ];

  public static readonly PBH_COUNTRY_CODES: any = [
    { code: '+91', name: '🇮🇳 +91' },
    { code: '+973', name: '🇧🇭 +973' },
    { code: '+57', name: '🇨🇴 +57' },
    { code: '+251', name: '🇪🇹 +251' },
    { code: '+358', name: '🇫🇮 +358' },
    { code: '+30', name: '🇬🇷 +30' },
    { code: '+968', name: '🇴🇲 +968' },
    { code: '+974', name: '🇶🇦 +974' },
    { code: '+7', name: '🇷🇺 +7' },
    { code: '+966', name: '🇸🇦 +966' },
    { code: '+65', name: '🇸🇬 +65' },
    { code: '+41', name: '🇨🇭 +41' },
    { code: '+992', name: '🇹🇯 +992' },
    { code: '+971', name: '🇦🇪 +971' },
    { code: '+44', name: '🇬🇧 +44' },
    { code: '+1', name: '🇺🇸 +1' },
  ];

  public static readonly TRIAL_VERSION_NAME: any = {
    'v1-399': 'Trial V1.1',
    'v1.1-399': 'Trial V1.1',
    'v2.0-399': 'Trial V2.0',
  };

  public static readonly TASK_CONTENT_ELEMENT_TYPE_HEADING: number = 1;
  public static readonly TASK_CONTENT_ELEMENT_TYPE_SCRIPT: number = 2;
  public static readonly TASK_CONTENT_ELEMENT_TYPE_QUESTION: number = 3;
  public static readonly TASK_CONTENT_ELEMENT_TYPE_CUSTOM_VIEW: number = 8;
  public static readonly TASK_CONTENT_ELEMENT_TYPE_DIVIDER: number = 9;
  public static readonly TASK_CONTENT_ELEMENT_TYPE_CUSTOM_QUESTION: number = 10;
  public static readonly TASK_CONTENT_ELEMENT_TYPE_CUSTOM: number = 20;

  public static readonly REPORT_STATUS_PENDING: number = 1;
  public static readonly REPORT_STATUS_DRAFT: number = 2;
  public static readonly REPORT_STATUS_PUBLISHED: number = 3;

  public static readonly ALLOWED_PAST_DATE: number = 1;
  public static readonly ALLOWED_FUTURE_DATE: number = 2;

  /* Task Statuses */
  public static readonly TASK_STATUS_PENDING: number = 1;
  public static readonly TASK_STATUS_STARTED: number = 2;
  public static readonly TASK_STATUS_IN_PROGRESS: number = 3;
  public static readonly TASK_STATUS_RESCHEDULED: number = 4;
  public static readonly TASK_STATUS_COMPLETED: number = 5;
  public static readonly TASK_STATUS_DISCARDED: number = 6;
  public static readonly TASK_STATUS_ESCALATED: number = 7;
  public static readonly TASK_STATUS_HIDDEN: number = 8;
  public static readonly TASK_STATUS_SUSPENDED: number = 9;
  public static readonly TASK_STATUS_ARCHIVED: number = 10;
  public static readonly TASK_STATUS_NOT_REQUIRED: number = 11;
  public static readonly TASK_STATUS_DRAFT: number = 12;
  public static readonly TASK_STATUS_SKIPPED: number = 13;
  public static readonly TASK_STATUS_EXPIRED: number = 14;

  /* Participation Statuses */
  public static readonly PARTICIPATION_STATUS_PENDING: number = 1;
  public static readonly PARTICIPATION_STATUS_MARKED_AS_READY: number = 2;
  public static readonly PARTICIPATION_STATUS_ONGOING: number = 3;
  public static readonly PARTICIPATION_STATUS_DEFERRED: number = 4;
  public static readonly PARTICIPATION_STATUS_HOLD: number = 5;
  public static readonly PARTICIPATION_STATUS_COMPLETED: number = 6;
  public static readonly PARTICIPATION_STATUS_INACTIVE: number = 7;
  public static readonly PARTICIPATION_STATUS_SUSPENDED: number = 8;

  public static readonly TASK_TYPE_INTERACTIONS: number = 16;
  public static readonly TASK_TYPE_PT_PLAN: number = 19;
  public static readonly TASK_TYPE_PT_PAIN_PLAN: number = 25;
  public static readonly TASK_TYPE_PSY_PLAN: number = 20;
  public static readonly TASK_TYPE_PSY_PLAN_INTERACTIONS: number = 21;

  public static readonly TASK_UID_NEW_REPORT: string = 'report-new';
  public static readonly TASK_UID_EDIT_REPORT: string = 'report-edit';
  public static readonly TASK_UID_NEW_ASSESSMENT: string = 'assessment-new';
  public static readonly TASK_UID_EDIT_ASSESSMENT: string = 'assessment-edit';
  public static readonly TASK_UID_SCHEDULE_APPOINTMENT: string =
    'appointment-schedule';
  public static readonly TASK_UID_SCHEDULE_CUSTOM_APPOINTMENT: string =
    'appointment-schedule-custom';
  public static readonly TASK_UID_RESCHEDULE_CUSTOM_APPOINTMENT: string =
    'appointment-reschedule-custom';
  public static readonly TASK_UID_PPT_PLAN: string = 'ppt_physiotherapy_plan';
  public static readonly TASK_UID_PSY_PLAN: string = 'ppl_psycology_plan';

  public static readonly CANCEL_RESCHEDULE_REASON: any = {
    PATIENT: 'Patient',
    FITTERFLY: 'Fitterfly',
  };

  public static readonly ASSESSMENT_STATUS: any = {
    1: { name: 'Pending', className: 'pending' },
    2: { name: 'In progress', className: 'progress' },
    3: { name: 'Completed', className: 'done' },
  };

  public static readonly RESOURCES: any[] = [
    { id: Constants.NUTRITION_COACH_ROLE, name: 'Nutrition  Coach', color: 'red' },
    { id: Constants.PROGRAM_ADVISOR_ROLE, name: 'Program Advisors', color: 'red' },
    { id: Constants.PHYSIOTHERAPIST_COACH_ROLE, name: 'Physio Coach', color: 'red' },
    { id: Constants.PSYCHOLOGIST_COACH_ROLE, name: 'Success Coach', color: 'red' },
    { id: Constants.CARE_MANAGER_ROLE, name: 'Member Support Executives', color: 'red' },
    { id: Constants.PHLEBOTOMIST_ROLE, name: 'Phlebotomist', color: 'red' },
    { id: Constants.QC_MANAGER_ROLE, name: 'QC Manager', color: 'red' },
    { id: Constants.NUTRITION_COACH_TEAM_LEAD_ROLE, name: 'Team Leader', color: 'red' },
    { id: 'patient', name: 'Members', color: 'blue' },
    { id: 'System', name: 'System', color: 'green' },
  ];
  public static readonly CARE_TEAM: any = {};

  public static readonly PROGRAM_TASKS: any = {
    1: { name: 'Pending', className: 'pending' },
    2: { name: 'Started', className: 'started' },
    3: { name: 'In progress', className: 'progress' },
    4: { name: 'Rescheduled', className: 'reschedule' },
    5: { name: 'Completed', className: 'done' },
    6: { name: 'Discarded', className: 'discard' },
    7: { name: 'Escalated', className: 'escalate' },
    8: { name: 'Hidden', className: 'hidden' },
    9: { name: 'Suspended', className: 'suspended' },
    10: { name: 'Archived', className: 'archived' },
    11: { name: 'Not Required', className: 'na' },
    14: { name: 'Expired', className: 'expired' },
  };

  /* CSE Account Settings */
  public static readonly CSE_ACCOUNT_SETTINGS_COLUMNS: any[] = [
    {
      name: 'Name',
      width: '200px',
    },
    {
      name: 'Email',
      width: '200px',
    },
    {
      name: 'Bucket size',
      width: '200px',
    },
    {
      name: 'Remaining capacity',
      width: '200px',
    },
    {
      name: 'Action',
      width: '200px',
    },
  ];

  /* Razorpay Transactions */
  public static readonly RAZORPAY_TRANSACTION_COLUMNS: any[] = [
    {
      name: 'Date',
      width: '200px',
    },
    {
      name: 'Payment Id',
      width: '200px',
    },
    {
      name: 'Order Id',
      width: '225px',
    },
    {
      name: 'Amount',
      width: '120px',
    },
    {
      name: 'Contact',
      width: '180px',
    },
    {
      name: 'Email',
      width: '200px',
    },
    {
      name: 'Status',
      width: '160px',
    },
    {
      name: 'Error Description',
      width: '550px',
    },
    {
      name: 'Error Reason',
      width: '160px',
    },
    {
      name: 'Notes',
      width: '160px',
    },
  ];

  /* Campaign Reports */
  public static readonly CAMPAIGN_REPORTS_COLUMNS: any[] = [
    {
      name: 'Date',
      width: '200px',
    },
    {
      name: 'Campaign ID',
      width: '200px',
    },
    {
      name: 'AD Group ID',
      width: '200px',
    },
    {
      name: 'AD ID',
      width: '200px',
    },
    {
      name: 'Campaign Type',
      width: '200px',
    },
    {
      name: 'Campaign',
      width: '200px',
    },
    {
      name: 'AD Group',
      width: '200px',
    },
    {
      name: 'AD Name',
      width: '200px',
    },
    {
      name: 'Campaign State',
      width: '200px',
    },
    {
      name: 'AD Group State',
      width: '200px',
    },
    {
      name: 'AD State',
      width: '200px',
    },
    {
      name: 'Landing Page URL',
      width: '200px',
    },
    {
      name: 'Impression',
      width: '200px',
    },
    {
      name: 'Clicks',
      width: '200px',
    },
    {
      name: 'Cost',
      width: '200px',
    },
    {
      name: 'Source',
      width: '200px',
    },
    {
      name: 'Views',
      width: '200px',
    },
    {
      name: 'Uploaded By',
      width: '200px',
    },
  ];

  public static readonly CAMPAIGN_REPORT_SOURCE: any[] = [
    { name: 'Facebook', value: 'Facebook' },
    { name: 'Google', value: 'Google' },
    { name: 'Gpay', value: 'Gpay' },
    { name: 'Quora', value: 'Quora' },
  ];

  /* Opportunity List */
  public static readonly OPPORTUNITY_LIST: any[] = [
    {
      name: 'Patient Details',
      class: 'width-16',
    },
    {
      name: 'Mobile No',
      class: 'width-16',
    },
    {
      name: 'Campaign',
      class: 'width-16',
    },
    {
      name: 'Program',
      class: 'width-16',
    },
    {
      name: 'Package',
      class: 'width-7',
    },
    {
      name: 'Created Date',
      class: 'width-12',
    },
    {
      name: 'Owner',
      class: 'width-7',
    },
    {
      name: 'Status',
      class: 'width-7',
    },
    {
      name: 'Lead Source',
      class: 'width-7',
    },
  ];

  /* Lead List */
  public static readonly LEAD_LIST_COLUMNS: string[] = [
    'Patient Details',
    'Mobile No.',
    'Campaign',
    'Program',
    'Package',
    'Created At',
    'Modified At',
    'Owner',
    'Status',
    'Sub Status',
    'Payment Status'
  ];

  /* Lead List Payment List */
  public static readonly LEAD_PAYMENT_STATUSES: {
    name: string;
    value: number;
  }[] = [
      { name: 'Failed', value: 0 },
      { name: 'Done', value: 1 },
      { name: 'Pending', value: 2 },
    ];

  // Referred By for Lead
  public static readonly REFERRED_BY_LEAD: { name: string; value: string }[] = [
    { name: 'Patient', value: 'patient' },
    { name: 'Coach', value: 'coach' },
    { name: 'Doctor', value: 'doctor' },
    { name: 'Employee', value: 'employee' },
  ];

  public static readonly INDIAN_STATES: { name: string }[] = [
    { name: 'Andaman and Nicobar Islands' },
    { name: 'Andhra Pradesh' },
    { name: 'Arunachal Pradesh' },
    { name: 'Assam' },
    { name: 'Bihar' },
    { name: 'Chandigarh' },
    { name: 'Chhattisgarh' },
    { name: 'Dadra and Nagar Haveli and Daman and Diu' },
    { name: 'Delhi' },
    { name: 'Goa' },
    { name: 'Gujarat' },
    { name: 'Haryana' },
    { name: 'Himachal Pradesh' },
    { name: 'Jammu and Kashmir' },
    { name: 'Jharkhand' },
    { name: 'Karnataka' },
    { name: 'Kerala' },
    { name: 'Ladakh' },
    { name: 'Lakshadweep' },
    { name: 'Madhya Pradesh' },
    { name: 'Maharashtra' },
    { name: 'Manipur' },
    { name: 'Meghalaya' },
    { name: 'Mizoram' },
    { name: 'Nagaland' },
    { name: 'Odisha' },
    { name: 'Puducherry' },
    { name: 'Punjab' },
    { name: 'Rajasthan' },
    { name: 'Sikkim' },
    { name: 'Tamil Nadu' },
    { name: 'Telangana' },
    { name: 'Tripura' },
    { name: 'Uttar Pradesh' },
    { name: 'Uttarakhand' },
    { name: 'West Bengal' },
  ];

  /* Invoice Master */
  public static readonly INVOICE_AMOUNT_STATUS: any[] = [
    { name: 'All', value: null },
    { name: 'Non Zero Amount', value: false },
    { name: 'Zero Amount', value: true },
  ];
  public static readonly INVOICE_VALIDATION_STATUS: any[] = [
    { name: 'All', value: null },
    { name: 'Pending Validation', value: false },
    { name: 'Validated', value: true },
  ];
  public static readonly INVOICE_SHARED_STATUS: any[] = [
    { name: 'All', value: null },
    { name: 'Not yet shared', value: false },
    { name: 'Shared', value: true },
  ];
  public static readonly INVOICE_CASH_STATUS: any[] = [
    { name: 'All', value: null },
    { name: 'Pending Cash Confirmation', value: false },
    { name: 'Cash Confirmed', value: true },
  ];
  public static readonly INVOICE_PAYMENT_MODE: any[] = [
    { name: 'All', value: null },
    { name: 'Online', value: 'online' },
    { name: 'Cash', value: 'cash' },
    { name: 'Cheque', value: 'cheque' },
  ];
  public static readonly INVOICE_ADD_ALLOWED_EMAILS: string[] = ['fenil.parikh@pbhealth.com', 'jambu.gunavant@pbhealth.com', 'raj.kharvar@pbhealth.com'];
  public static readonly INVOICE_LIST: any[] = [
    {
      name: 'Validation Status',
      width: '140px',
    },
    {
      name: 'Invoice Date',
      width: '200px',
    },
    {
      name: 'Created Date',
      width: '200px',
    },
    {
      name: 'Name',
      width: '170px',
    },
    {
      name: 'Mobile Number',
      width: '140px',
    },
    {
      name: 'Title',
      width: '200px',
    },
    {
      name: 'Program',
      width: '160px',
    },
    {
      name: 'Campaign Channel',
      width: '140px',
    },
    {
      name: 'Amount',
      width: '100px',
    },
    {
      name: 'Mode of Payment',
      width: '150px',
    },
    {
      name: 'RazorPay Details',
      width: '200px',
    },
    {
      name: 'State',
      width: '150px',
    },
  ];

  public static readonly INVOICE_DETAIL_TABS: any[] = [
    { label: 'Invoice' },
    { label: 'Credit Note' },
  ];

  public static readonly CAMPAIGN_CHANNELS: any[] = [
    { name: 'Doctor', value: 'Doctor' },
    { name: 'B2C', value: 'B2C' },
    { name: 'B2B', value: 'B2B' },
  ];

  public static readonly REFERRAL_STATUSES: { id: number; name: string }[] = [
    {
      id: 1,
      name: 'Invite Sent',
    },
    {
      id: 2,
      name: 'Invite Accepted',
    },
    {
      id: 3,
      name: 'Invite Declined',
    },
    {
      id: 4,
      name: 'Invite Unlocked',
    },
  ];

  public static readonly REFERRAL_SOURCES: { name: string; value: string }[] = [
    {
      name: 'DTx',
      value: 'dtx',
    },
    {
      name: 'App',
      value: 'app',
    },
    {
      name: 'Website',
      value: 'website',
    },
  ];

  // Lead Details
  public static readonly LEAD_REFERRED_BY: any[] = [
    { name: 'Patient', value: 'patient' },
    { name: 'Coach', value: 'coach' },
    { name: 'Doctor', value: 'doctor' },
    { name: 'Employee', value: 'employee' },
  ];

  public static readonly LEAD_LANGUAGE: any[] = [
    { name: 'Patient', value: 'patient' },
    { name: 'Coach', value: 'coach' },
    { name: 'Doctor', value: 'doctor' },
    { name: 'Employee', value: 'employee' },
  ];

  /* Second Level Sidebar Routes */
  public static readonly OVERVIEW_ROUTE: string = 'overview';
  public static readonly ASSESSMENTS_ROUTE: string = 'assessments';
  public static readonly TASKS_ROUTE: string = 'tasks';
  public static readonly MEDICAL_DETAILS_ROUTE: string = 'medical-details';
  public static readonly PLANS_ROUTE: string = 'plans';
  public static readonly REPORTS_ROUTE: string = 'reports';
  public static readonly REFERRALS_ROUTE: string = 'referrals';
  public static readonly TRACKERS_AND_JOURNALS_ROUTE: string = 'trackers-and-journals';
  public static readonly CGMS_ROUTE: string = 'cgms';
  public static readonly CGMS_TIMELINE_ROUTE: string = 'timeline';
  public static readonly CGMS_RAW_DATA_ROUTE: string = 'raw-data';
  public static readonly GROUP_SESSIONS_ROUTE: string = 'group-sessions';
  public static readonly INTERNAL_SUPPORT_ROUTE: string = 'internal-support';
  public static readonly INVESTIGATIONS_ROUTE: string = 'investigations';
  public static readonly NUTRITION_ROUTE: string = 'nutrition';
  public static readonly KEY_OBSERVATIONS_ROUTE: string = 'key-observations';
  public static readonly SUGGESTED_RDA_ROUTE: string = 'suggested-rda';
  public static readonly DIET_PLAN_ROUTE: string = 'diet-plan';
  public static readonly MEDICAL_RECORDS_ROUTE: string = 'medical-records';
  public static readonly VERBAL_COMPLIANCE_ROUTE: string = 'verbal-compliance';
  public static readonly MEAL_CALENDAR_ROUTE: string = 'meal-calendar';
  public static readonly PROFILE_ROUTE: string = 'health-profile';
  public static readonly PROGRAM_DETAILS_ROUTE: string = 'program-details';
  public static readonly GOALS_ROUTE: string = 'goals';
  public static readonly OUTCOMES_ROUTE: string = 'outcomes';
  public static readonly ANTHROPOMETRY_ROUTE: string = 'anthropometry';
  public static readonly BLOOD_PRESSURE_DIARY_ROUTE: string = 'blood-pressure-diary';
  public static readonly FITNESS_ROUTE: string = 'fitness';
  public static readonly MEDICATION_ROUTE: string = 'medication';
  public static readonly SYMPTOMS_ROUTE: string = 'symptoms';
  public static readonly HEART_HEALTH_ROUTE: string = 'heart-health';
  public static readonly HEART_RATE_ROUTE: string = 'heart-rate';
  public static readonly HEART_RATE_VARIABILITY_ROUTE: string = 'heart-rate-variability';
  public static readonly MEMBER_SUPPORT_ROUTE: string = 'member-support';
  public static readonly UPSELL_AND_CROSS_SELL_ROUTE: string = 'upsell-and-cross-sell';
  public static readonly RECOMMEND_PRODUCTS_ROUTE: string = 'recommend-products';
  public static readonly ORDER_HISTORY_ROUTE: string = 'order-history';
  public static readonly UPSELL_TASKS_ROUTE: string = 'upsell-tasks';
  public static readonly MEMBER_DETAILS_SIDEBAR_ITEMS: MemberSidebarItem[] = [
    {
      navId: 1,
      navTitle: 'Overview',
      navUrl: Constants.OVERVIEW_ROUTE,
      navIconClass: 'icon-nav-member-overview',
      navIconActiveClass: 'icon-nav-member-overview-active',
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.EVENT_ADMIN_ROLE,
        Constants.SESSION_INCHARGE_ROLE,
        Constants.PROGRAM_ADVISOR_ROLE,
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.ONBOARDING_AGENT_ROLE,
        Constants.ONBOARDING_AGENT_LEAD_ROLE,
        Constants.ONBOARDING_COACH_ROLE,
      ],
      navChildArr: [
        {
          navChildId: 1,
          navChildTitle: ' Health Profile',
          navChildUrl: `${Constants.OVERVIEW_ROUTE}/${Constants.PROFILE_ROUTE}`,
        },
        {
          navChildId: 2,
          navChildTitle: 'Program Details',
          navChildUrl: `${Constants.OVERVIEW_ROUTE}/${Constants.PROGRAM_DETAILS_ROUTE}`,
        },
        {
          navChildId: 3,
          navChildTitle: 'Outcomes',
          navChildUrl: `${Constants.OVERVIEW_ROUTE}/${Constants.OUTCOMES_ROUTE}`,
        },
      ],
      restrictedClients: [],
    },
    {
      navId: 21,
      navTitle: 'Goals',
      navUrl: Constants.GOALS_ROUTE,
      navIconClass: 'icon-nav-member-goals',
      navIconActiveClass: 'icon-nav-member-goals-active',
      navIconPath: 'assets/icons/member-navigation-icons/nav-member-goals.svg',
      navIconActivePath: 'assets/icons/member-navigation-icons/nav-member-goals-active.svg',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.NUTRITION_COACH_ROLE,
        Constants.NUTRITION_COACH_TEAM_LEAD_ROLE,
        Constants.PSYCHOLOGIST_COACH_ROLE,
        Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE,
        Constants.PHYSIOTHERAPIST_COACH_ROLE,
        Constants.PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE,
        Constants.ONBOARDING_COACH_ROLE,
      ],
      restrictedClients: [],
    },
    {
      navId: 2,
      navTitle: 'Tasks',
      navUrl: Constants.TASKS_ROUTE,
      navIconClass: 'icon-nav-member-tasks',
      navIconActiveClass: 'icon-nav-member-tasks-active',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.EVENT_ADMIN_ROLE,
        Constants.SESSION_INCHARGE_ROLE,
        Constants.ONBOARDING_AGENT_ROLE,
        Constants.ONBOARDING_AGENT_LEAD_ROLE,
        Constants.PROGRAM_ADVISOR_ROLE,
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.PROGRAM_ADVISOR_CALLER_ACCESS_ROLE,
        Constants.ONBOARDING_COACH_ROLE,
      ],
      restrictedClients: [],
    },
    {
      navId: 20,
      navTitle: 'Upsell Tasks',
      navUrl: Constants.UPSELL_TASKS_ROUTE,
      navIconClass: 'icon-nav-member-tasks',
      navIconActiveClass: 'icon-nav-member-tasks-active',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.PROGRAM_ADVISOR_ROLE,
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
      ],
      restrictedClients: [Constants.ABHI_PATH_KEY],
    },
    {
      navId: 3,
      navTitle: 'Assessments',
      navUrl: Constants.ASSESSMENTS_ROUTE,
      navIconClass: 'icon-nav-member-assessments',
      navIconActiveClass: 'icon-nav-member-assessments-active',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.EVENT_ADMIN_ROLE,
        Constants.SESSION_INCHARGE_ROLE,
        Constants.ONBOARDING_COACH_ROLE
      ],
      restrictedClients: [],
    },
    {
      navId: 4,
      navTitle: 'Anthropometry',
      navUrl: Constants.ANTHROPOMETRY_ROUTE,
      navIconClass: 'icon-nav-member-anthropometry',
      navIconActiveClass: 'icon-nav-member-anthropometry',
      navChildArr: [],
      visibleToCoaches: [...Constants.ALL_ROLES, Constants.ONBOARDING_COACH_ROLE],
      restrictedClients: [],
    },
    {
      navId: 5,
      navTitle: 'Medical Details',
      navUrl: Constants.MEDICAL_DETAILS_ROUTE,
      navIconClass: 'icon-nav-member-medical-details',
      navIconActiveClass: 'icon-nav-member-medical-details-active',
      visibleToCoaches: [...Constants.ALL_ROLES, Constants.ONBOARDING_COACH_ROLE],
      navChildArr: [
        {
          navChildId: 1,
          navChildTitle: 'BP Diary',
          navChildUrl: `${Constants.MEDICAL_DETAILS_ROUTE}/${Constants.BLOOD_PRESSURE_DIARY_ROUTE}`,
        },
        {
          navChildId: 2,
          navChildTitle: 'Medication',
          navChildUrl: `${Constants.MEDICAL_DETAILS_ROUTE}/${Constants.MEDICATION_ROUTE}`,
        },
        {
          navChildId: 3,
          navChildTitle: 'Symptoms',
          navChildUrl: `${Constants.MEDICAL_DETAILS_ROUTE}/${Constants.SYMPTOMS_ROUTE}`,
        },
        {
          navChildId: 4,
          navChildTitle: 'Medical Records',
          navChildUrl: `${Constants.MEDICAL_DETAILS_ROUTE}/${Constants.MEDICAL_RECORDS_ROUTE}`,
        },
        {
          navChildId: 5,
          navChildTitle: 'Verbal Compliance',
          navChildUrl: `${Constants.MEDICAL_DETAILS_ROUTE}/${Constants.VERBAL_COMPLIANCE_ROUTE}`,
        },
      ],
      restrictedClients: [],
    },
    {
      navId: 6,
      navTitle: 'Investigations',
      navUrl: Constants.INVESTIGATIONS_ROUTE,
      navIconClass: 'icon-nav-member-investigations',
      navIconActiveClass: 'icon-nav-member-investigations-active',
      navChildArr: [],
      visibleToCoaches: [...Constants.ALL_ROLES, Constants.ONBOARDING_COACH_ROLE],
      restrictedClients: [],
    },
    {
      navId: 7,
      navTitle: 'CGMS',
      navUrl: Constants.CGMS_ROUTE,
      navIconClass: 'icon-nav-member-cgms',
      navIconActiveClass: 'icon-nav-member-cgms-active',
      visibleToCoaches: Constants.ALL_ROLES,
      navChildArr: [
        {
          navChildId: 1,
          navChildTitle: 'Timeline',
          navChildUrl: `${Constants.CGMS_ROUTE}/${Constants.CGMS_TIMELINE_ROUTE}`,
        },
        {
          navChildId: 2,
          navChildTitle: 'Raw Data',
          navChildUrl: `${Constants.CGMS_ROUTE}/${Constants.CGMS_RAW_DATA_ROUTE}`,
        },
      ],
      restrictedClients: [Constants.ABHI_PATH_KEY],
    },
    {
      navId: 8,
      navTitle: 'Nutrition',
      navUrl: Constants.NUTRITION_ROUTE,
      navIconClass: 'icon-nav-member-nutrition',
      navIconActiveClass: 'icon-nav-member-nutrition-active',
      visibleToCoaches: [...Constants.ALL_ROLES, Constants.ONBOARDING_COACH_ROLE],
      navChildArr: [
        {
          navChildId: 1,
          navChildTitle: 'Meal Calendar',
          navChildUrl: `${Constants.NUTRITION_ROUTE}/${Constants.MEAL_CALENDAR_ROUTE}`,
        },
        {
          navChildId: 2,
          navChildTitle: 'Key Observations',
          navChildUrl: `${Constants.NUTRITION_ROUTE}/${Constants.KEY_OBSERVATIONS_ROUTE}`,
        },
        {
          navChildId: 3,
          navChildTitle: 'Suggested RDA',
          navChildUrl: `${Constants.NUTRITION_ROUTE}/${Constants.SUGGESTED_RDA_ROUTE}`,
        },
        {
          navChildId: 4,
          navChildTitle: 'Diet Plan',
          navChildUrl: `${Constants.NUTRITION_ROUTE}/${Constants.DIET_PLAN_ROUTE}`,
        },
      ],
      restrictedClients: [],
    },
    {
      navId: 9,
      navTitle: 'Trackers & Journals',
      navUrl: Constants.TRACKERS_AND_JOURNALS_ROUTE,
      navIconClass: 'icon-nav-member-trackers',
      navIconActiveClass: 'icon-nav-member-trackers-active',
      navChildArr: [],
      visibleToCoaches: [
        Constants.PSYCHOLOGIST_COACH_ROLE,
        Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE,
      ],
      restrictedClients: [Constants.ABHI_PATH_KEY],
    },
    {
      navId: 10,
      navTitle: 'Fitness',
      navUrl: Constants.FITNESS_ROUTE,
      navIconClass: 'icon-nav-member-fitness',
      navIconActiveClass: 'icon-nav-member-fitness-active',
      navChildArr: [],
      visibleToCoaches: Constants.ALL_ROLES,
      restrictedClients: [],
    },
    {
      navId: 16,
      navTitle: 'Heart Health',
      navUrl: Constants.HEART_HEALTH_ROUTE,
      navIconClass: 'icon-nav-member-heart-health',
      navIconActiveClass: 'icon-nav-member-heart-health-active',
      visibleToCoaches: Constants.ALL_ROLES,
      navChildArr: [
        {
          navChildId: 1,
          navChildTitle: 'Heart Rate',
          navChildUrl: `${Constants.HEART_HEALTH_ROUTE}/${Constants.HEART_RATE_ROUTE}`,
        },
        {
          navChildId: 2,
          navChildTitle: 'Heart Rate Variability',
          navChildUrl: `${Constants.HEART_HEALTH_ROUTE}/${Constants.HEART_RATE_VARIABILITY_ROUTE}`,
        }
      ],
      restrictedClients: [Constants.ABHI_PATH_KEY],
    },
    {
      navId: 11,
      navTitle: 'Reports',
      navUrl: Constants.REPORTS_ROUTE,
      navIconClass: 'icon-nav-member-reports',
      navIconActiveClass: 'icon-nav-member-reports-active',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.EVENT_ADMIN_ROLE,
        Constants.SESSION_INCHARGE_ROLE,
      ],
      restrictedClients: [],
    },
    {
      navId: 12,
      navTitle: 'Plans',
      navUrl: Constants.PLANS_ROUTE,
      navIconClass: 'icon-nav-member-plans',
      navIconActiveClass: 'icon-nav-member-plans-active',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.EVENT_ADMIN_ROLE,
        Constants.SESSION_INCHARGE_ROLE,
      ],
      restrictedClients: [],
    },
    {
      navId: 14,
      navTitle: 'Member Support',
      navUrl: Constants.MEMBER_SUPPORT_ROUTE,
      navIconClass: 'icon-nav-member-member-support',
      navIconActiveClass: 'icon-nav-member-member-support-active',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.EVENT_ADMIN_ROLE,
        Constants.SESSION_INCHARGE_ROLE,
        Constants.ONBOARDING_COACH_ROLE,
      ],
      restrictedClients: [],
    },
    {
      navId: 16,
      navTitle: 'Referrals',
      navUrl: Constants.REFERRALS_ROUTE,
      navIconClass: 'icon-nav-member-referrals',
      navIconActiveClass: 'icon-nav-member-referrals-active',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.EVENT_ADMIN_ROLE,
        Constants.SESSION_INCHARGE_ROLE,
        Constants.ONBOARDING_COACH_ROLE,
      ],
      restrictedClients: [Constants.ABHI_PATH_KEY],
    },
    {
      navId: 17,
      navTitle: 'Group Sessions',
      navUrl: Constants.GROUP_SESSIONS_ROUTE,
      navIconClass: 'icon-nav-member-gs',
      navIconActiveClass: 'icon-nav-member-gs-active',
      navChildArr: [],
      visibleToCoaches: [
        Constants.CARE_MANAGER_ROLE,
        Constants.CARE_MANAGER_TEAM_LEAD_ROLE,
        Constants.NUTRITION_COACH_ROLE,
        Constants.NUTRITION_COACH_TEAM_LEAD_ROLE,
        Constants.PSYCHOLOGIST_COACH_ROLE,
        Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE,
        Constants.PHYSIOTHERAPIST_COACH_ROLE,
        Constants.PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE,
        Constants.EVENT_ADMIN_ROLE,
        Constants.SESSION_INCHARGE_ROLE,
      ],
      restrictedClients: [],
    },
    /* Hidden for everyone for now
    {
      navId: 18,
      navTitle: 'Upsell & Cross Sell',
      navUrl: Constants.UPSELL_AND_CROSS_SELL_ROUTE,
      navIconClass: 'icon-nav-member-upsell-crosssell',
      navIconActiveClass: 'icon-nav-member-upsell-crosssell-active',
      navChildArr: [
        {
          navChildId: 1,
          navChildTitle: 'Recommend Products',
          navChildUrl: `${Constants.UPSELL_AND_CROSS_SELL_ROUTE}/${Constants.RECOMMEND_PRODUCTS_ROUTE}`,
        }
      ],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.PROGRAM_ADVISOR_ROLE,
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.ONBOARDING_COACH_ROLE,
      ],
      restrictedClients: [],
    },
    */
    {
      navId: 19,
      navTitle: 'Order History',
      navUrl: Constants.ORDER_HISTORY_ROUTE,
      navIconClass: 'icon-nav-member-order-history-inactive',
      navIconActiveClass: 'icon-nav-member-order-history-active',
      navChildArr: [],
      visibleToCoaches: [
        ...Constants.ALL_ROLES,
        Constants.PROGRAM_ADVISOR_ROLE,
        Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE,
        Constants.ONBOARDING_COACH_ROLE,
      ],
      restrictedClients: [Constants.ABHI_PATH_KEY],
    }
  ];

  public static readonly MEMBER_OVERVIEW_TABS: any[] = [
    { label: 'Profile' },
    { label: 'Program Details' },
  ];

  public static readonly OVERVIEW_PROFILE_MODAL_TABS: { label: string }[] = [
    { label: 'Member Details' },
    { label: 'Doctor Details' },
  ];

  public static readonly OVERVIEW_PROGRAM_PHASES_COLUMNS: string[] = [
    'Phase Name',
    'Start Date',
    'End Date',
  ];

  /* Member Details - Plans*/
  public static readonly MEMBER_DETAILS_PLANS_COLUMN: any[] = [
    {
      name: 'Plan Name',
      width: '300px',
    },
    {
      name: 'Speciality',
      width: '200px',
    },
    {
      name: 'Published On',
      width: '200px',
    },
    {
      name: 'Published By',
      width: '200px',
    },
    {
      name: 'Status',
      width: '200px',
    },
    {
      name: 'Actions',
      width: '100px',
    },
  ];

  public static readonly PLANS_SPECIALITY_TYPES: any = {
    [Constants.PHYSIOTHERAPIST_COACH_ROLE]: {
      key: Constants.PHYSIOTHERAPIST_COACH_ROLE,
      name: 'Physiotherapist',
    },
    [Constants.PSYCHOLOGIST_COACH_ROLE]: {
      key: Constants.PSYCHOLOGIST_COACH_ROLE,
      name: 'Psychologist',
    },
  };

  public static readonly PLAN_STATUS_TYPES: any = {
    4: {
      key: 4,
      name: 'Draft',
    },
    5: {
      key: 5,
      name: 'Published',
    },
  };

  /* Member Details - Reports */
  public static readonly MEMBER_DETAILS_REPORTS_COLUMN: any[] = [
    {
      name: 'Report Name',
      width: '250px',
    },
    {
      name: 'Speciality',
      width: '100px',
    },
    {
      name: 'Published On',
      width: '200px',
    },
    {
      name: 'Updated By',
      width: '150px',
    },
    {
      name: 'Status',
      width: '100px',
    },
    {
      name: 'Actions',
      width: '50px',
    },
  ];

  public static readonly REPORT_SPECIALITY_TYPES: any = {
    [Constants.PHYSIOTHERAPIST_COACH_ROLE]: {
      key: Constants.PHYSIOTHERAPIST_COACH_ROLE,
      name: 'Physiotherapy',
    },
    [Constants.PSYCHOLOGIST_COACH_ROLE]: {
      key: Constants.PSYCHOLOGIST_COACH_ROLE,
      name: 'Psychology',
    },
    [Constants.NUTRITION_COACH_ROLE]: {
      key: Constants.NUTRITION_COACH_ROLE,
      name: 'Nutrition',
    },
    cv_score: {
      key: 'cv_score',
      name: 'CV Score',
    },
    heart_health_report: {
      key: 'heart_health_report',
      name: 'Heart Health',
    },
    gut_score_report: {
      key: 'gut_score_report',
      name: 'Gut Score',
    },
    diabetes_reversal_report: {
      key: 'diabetes_reversal_report',
      name: 'Diabetes Reversal',
    },
    lifestyle_and_wellness_report: {
      key: 'lifestyle_and_wellness_report',
      name: 'Lifestyle and Wellness',
    }
  };

  public static readonly REPORT_STATUS_TYPES: any = {
    1: {
      key: 1,
      name: 'Pending',
      className: 'pending',
    },
    2: {
      key: 2,
      name: 'Draft / Updated',
      className: 'draft',
    },
    3: {
      key: 3,
      name: 'Published',
      className: 'done',
    },
  };

  public static readonly CGMS_SMBG_MAPPING: {
    name: string;
    width: string;
    tooltipText?: string;
  }[] = [
      {
        name: 'SMBG type',
        width: '100px',
      },
      {
        name: 'SMBG reading time',
        width: '150px',
      },
      {
        name: 'SMBG value',
        width: '100px',
      },
      {
        name: 'CGMS reading time',
        width: '150px',
      },
      {
        name: 'CGMS value',
        width: '100px',
      },
      {
        name: 'Data variability',
        width: '150px',
        tooltipText: 'Cgms chart moving before 45 minutes and after 45 minutes of CGMS reading. If data variability is less then 10 then only fasting reading should be considered to calculate MARD'
      },
      {
        name: 'ARD',
        width: '100px',
      },
    ];

  /* Member Details - Assessments */
  public static readonly ASSESSMENTS_COLUMNS: {
    name: string;
    width: string;
  }[] = [
      {
        name: 'Assessment Name',
        width: '420px',
      },
      {
        name: 'Source',
        width: '190px',
      },
      {
        name: 'Key',
        width: '310px',
      },
      {
        name: 'Assessed On',
        width: '245px',
      },
      // {
      //   name: 'Assessed By',
      //   width: '200px'
      // },
      {
        name: 'Status',
        width: '200px',
      },
      {
        name: 'Actions',
        width: '200px',
      },
    ];

  public static readonly ASSESSMENT_STATUSES: any = {
    1: {
      id: 1,
      name: 'Pending',
    },
    2: {
      id: 2,
      name: 'In Progress',
    },
    3: {
      id: 3,
      name: 'Completed',
    },
  };

  /* Member Details - Tasks */
  public static readonly MEMBER_TASKS_TABS: any[] = [
    { label: 'Scheduled' },
    { label: 'Adhoc' },
    { label: 'Support Tasks' }
  ];

  public static readonly MEMBER_TASKS_COLUMNS: any[] = [
    {
      name: 'Tasks',
      width: '550px',
    },
    {
      name: 'Owner Name',
      width: '190px',
    },
    {
      name: 'Date',
      width: '250px',
    },
    {
      name: 'Reschedule On',
      width: '200px',
    },
    {
      name: 'Expiry Date',
      width: '200px',
    },
    {
      name: 'Status',
      width: '150px',
    },
    {
      name: 'RC Left',
      width: '100px',
    },
    {
      name: 'Call Attempts',
      width: '100px',
    },
    {
      name: 'Actions',
      width: '100px',
    },
  ];

  public static readonly MEMBER_TASKS_TYPES: any[] = [
    {
      id: 1,
      type: 'All Tasks',
    },
    {
      id: 2,
      type: 'All Appointments',
    },
    {
      id: 3,
      type: 'Only Scheduled Appointments',
    },
    {
      id: 4,
      type: 'Only Unscheduled Appointments',
    },
  ];

  public static readonly MEMBER_TASKS_STATUSES: any[] = [
    {
      id: 5,
      name: 'Completed',
    },
    {
      id: 6,
      name: 'Discarded',
    },
    {
      id: 3,
      name: 'Pending / In Progress / Reschedule',
    },
    {
      id: 10,
      name: 'Archived',
    },
    {
      id: 9,
      name: 'Suspended',
    },
    {
      id: 11,
      name: 'Not Required',
    },
    {
      id: 14,
      name: 'Expired / Lapsed',
    },
  ];

  public static readonly MEMBER_TASKS_ROLES: any[] = [
    {
      role: Constants.PRIMARY_OPERATION_MANAGER_ROLE,
      display_name: 'Primary Operation Manager',
      key: 'is_primary_operation_manager',
      name: 'Primary Operation Manager',
    },
    {
      role: Constants.CARE_MANAGER_ROLE,
      display_name: 'Member Support Executive',
      key: 'is_care_manager',
      name: 'Care Manager',
    },
    {
      role: Constants.ONBOARDING_AGENT_ROLE,
      display_name: 'Onboarding Agent',
      key: 'onboarding_agent',
      name: 'Onboarding Agent',
    },
    {
      role: Constants.ONBOARDING_COACH_ROLE,
      display_name: 'Onboarding Coach',
      key: 'onboarding_coach',
      name: 'Onboarding Coach',
    },
    {
      role: Constants.NUTRITION_COACH_ROLE,
      display_name: 'Nutrition Coach',
      key: 'is_coach',
      name: 'Primary Coach',
    },
    {
      role: Constants.PHYSIOTHERAPIST_COACH_ROLE,
      display_name: 'Physio Coach',
      key: 'is_physiotherapist',
      name: 'Physiotherapist',
    },
    {
      role: Constants.PSYCHOLOGIST_COACH_ROLE,
      display_name: 'Success Coach',
      key: 'is_psychologist',
      name: 'Psychologist',
    },
    {
      role: Constants.DOCTOR_ROLE,
      display_name: 'Doctor',
      key: 'is_doctor',
      name: 'Doctor',
    },
    {
      role: 'patient',
      display_name: 'Member',
      key: 'patient',
      name: 'Patient',
    },
  ];

  public static readonly REASSIGN_TASK_KEY = 'reassign_task';
  public static readonly MARK_AS_COMPLETE_KEY = 'mark_as_complete';
  public static readonly COPY_MEET_LINK_KEY = 'copy_meet_link';
  public static readonly RESCHEDULE_KEY = 'reschedule';
  public static readonly DISCARD_KEY = 'discard';
  public static readonly RESET_REMIND_ON_KEY = 'reset_remind_on';
  public static readonly RESET_TO_PENDING_KEY = 'reset_to_pending';
  public static readonly MARK_AS_SUSPEND_KEY = 'mark_as_suspend';
  public static readonly ENABLE_TASK_KEY = 'enable_task';
  public static readonly VIEW_LOGS_KEY = 'view_logs';
  public static readonly RESET_EXPIRY_DATE_KEY = 'reset_expiry_date';
  public static readonly CANCEL_APPOINTMENT_KEY = 'cancel_appointment';
  public static readonly BOOK_APPOINTMENT_KEY = 'book_appointment';
  public static readonly ESCALATE_TASK_KEY = 'escalate_task';
  public static readonly ASSIGN_TASK_TO_MSE_KEY = 'assign_task_to_MSE';
  public static readonly EDIT_CONTACT_NOTE_KEY = 'edit_contact_note';
  public static readonly RAISE_CLICKUP_TICKET = 'raise_clickup_ticket';
  public static readonly VIEW_CLICKUP_TICKET = 'view_clickup_ticket';
  public static readonly ALLOW_CALLING_KEY = 'allow_calling';

  public static readonly UPDATE_CARE_TEAM_KEY = 'update_care_team';
  public static readonly START_PROGRAM_KEY = 'start_program';
  public static readonly CHANGE_PROGRAM_KEY = 'change_program';
  public static readonly REGENERATE_TASKS_KEY = 'regenerate_tasks';
  public static readonly MARK_AS_COMPLETED_KEY = 'mark_as_completed';
  public static readonly MARK_AS_INACTIVE_KEY = 'mark_as_inactive';
  public static readonly MARK_AS_HOLD_KEY = 'mark_as_hold';
  public static readonly MARK_AS_RESUME_KEY = 'mark_as_resume';
  public static readonly CHANGE_ORDER_SERVICES = 'change_order_services';
  public static readonly SYNC_TO_LSQ = 'sync_to_lsq';

  public static readonly PROGRAM_TASK_LOGS: any = {
    1: "Task Started",
    2: "Task Completed",
    3: "Task Rescheduled",
    4: "Task Discarded",
    5: "Appointment Booking",
    6: "Reminder Sent",
    7: "Task Archived",
    8: "Task Suspended",
    9: "Task Reset",
    10: "Reassign",
    11: "Expected on date changed",
    12: "Reset Remind On",
    13: "Not Required",
    14: "Task Cancel",
    15: "Ask to CM",
    16: "Task Published",
    17: "Task Draft",
    18: "Other Tasks",
    19: "Ringing, not received",
    20: "Could not connect",
    21: "Call successful",
    22: "Call attempt",
    23: "Task Expired",
    24: "Program resume date changed",
    25: "Member request for refund",
    26: "Member request to suspend program",
    27: "Pending",
    28: "Ask to call back",
    29: "Task Assigned",
    30: "Task Unassigned",
    31: "Task Escalated",
    32: "Manual Booking",
    33: "Call Disposition & Subdisposition",
    34: "Non Booked Task Reminder",
    35: "Documentation",
    36: "Internal Support Task generated",
    37: "Internal Support Task Completed",
    38: "WhatsApp Notification",
    39: "Auto IVR Notification",
  };

  public static readonly VIEW_LOG_COLUMNS: any = [
    {
      name: 'Date Time',
      width: '100px',
    },
    {
      name: 'Action',
      width: '150px',
    },
    {
      name: 'Remarks',
      width: '200px',
    },
    {
      name: 'Task Owner Type',
      width: '150px',
    },
    {
      name: 'Task Owner Name',
      width: '150px',
    },
    {
      name: 'Action Taken By Type',
      width: '150px',
    },
    {
      name: 'Action Taken By Name',
      width: '170px',
    },
  ];

  public static readonly TASK_LOGS_ACTION_TYPES: any = {
    2: {
      title: 'Completed',
      class: 'done',
    },
    3: {
      title: 'Rescheduled',
      class: 'reschedule',
    },
    4: {
      title: 'Discarded',
      class: 'discard',
    },
    5: {
      title: 'Appointment Booked',
      class: 'started',
    },
    7: {
      title: 'Archived',
      class: 'archived',
    },
    12: {
      title: 'Reset Remind On',
      class: 'reschedule',
    },
    14: {
      title: 'Cancel',
      class: 'cancel',
    },
    15: {
      title: 'Ask to CM',
      class: 'ask-to-cm',
    },
    19: {
      title: 'Rescheduled',
      class: 'reschedule',
    },
    20: {
      title: 'Rescheduled',
      class: 'reschedule',
    },
    23: {
      title: 'Lapsed',
      class: 'expired',
    },
    24: {
      title: 'Completed',
      class: 'done',
    },
    25: {
      title: 'Completed',
      class: 'done',
    },
    26: {
      title: 'Completed',
      class: 'done',
    },
    27: {
      title: 'Pending',
      class: 'pending',
    },
    31: {
      title: 'Task Escalated',
      class: 'done'
    },
    32: {
      title: 'Manual Booking',
      class: 'manual-booking'
    },
    35: {
      title: 'Documentation',
      class: 'documentation'
    },
    36: {
      title: 'Internal Support Task generated',
      class: 'started'
    },
    37: {
      title: 'Internal Support Task Completed',
      class: 'done'
    },
    38: {
      title: 'WhatsApp Notification',
      class: 'whatsapp-notification'
    },
    39: {
      title: 'Auto IVR Notification',
      class: 'auto-ivr-notification'
    }
  };

  public static readonly CANCELLATION_REASONS: any[] = [
    {
      title: 'Member No Show',
      value: 'memeber_no_show',
    },
    {
      title: 'Member Cancellation Request',
      value: 'member_cancellation_request',
    },
    {
      title: 'Cancellation By Coach',
      value: 'cancel_by_coach',
    },
  ];

  public static readonly CALL_TYPES: string[] = [
    // TODO: Update this data structure to support Cube, Exotel, Manual based on client configuration
    'Cube',
    'Manual',
  ];

  public static readonly EXOPHONE_CALL_TYPE: string = 'Exophone';

  public static readonly EXOPHONE_CHANNEL_NUMBER: string = '09240920016';

  public static readonly WORK_STYLE_TYPES: any[] = [
    {
      key: 'Home Maker',
      value: 'Home Maker'
    },
    {
      key: 'Desk Job',
      value: 'Desk Job'
    },
    {
      key: 'Field Work',
      value: 'Field Work'
    },
    {
      key: 'Sports Person',
      value: 'Sports Person'
    },
    {
      key: 'Others',
      value: 'Others'
    }
  ];

  public static readonly MEAL_TYPES: any = {
    'pre_breakfast': 'Pre Breakfast',
    'breakfast': 'Breakfast',
    'mid_morning': 'Mid Morning',
    'lunch': 'Lunch',
    'snacks': 'Snacks',
    'mid_evening': 'Mid Evening',
    'dinner': 'Dinner',
    'bedtime': 'Bedtime',
  };

  public static readonly DEFAULT_BLOOD_SUGAR_TIMES: {[key: string]: string} = {
    'fasting_value': '07:00',
    'post_breakfast_value': '10:00',
    'pre_lunch_value': '13:00',
    'post_lunch_value': '15:00',
    'pre_dinner_value': '21:00',
    'post_dinner_value': '23:00',
  };

  public static readonly DIET_PREFERENCES: {[key: string]: string[]} = {
    'Veg': ['Veg', 'Dairy Products'],
    'Vegan': ['Veg'],
    'Eggetarian': ['Egg'],
    'Jain': ['Jain'],
    'Non-Veg': [],
  };

  public static readonly NON_VEG_DIET_PREFERENCES: {[key: string]: string[]} = {
    'Poultry': ['Egg', 'Chicken'],
    'Seafood': ['Fish'],
    'Mutton': ['Mutton'],
    'Beef': ['Beef'],
    'Pork': ['Pork'],
  };

  public static readonly MEAL_TYPES_KEY_VALUE_PAIR: {
    key: string,
    value: string,
    selectedAndDisabled: boolean,
    beverageOptions?: {key: string, value: string}[],
    selectedBeverage?: {key: string, value: string} | null
  }[] = [
    { key: 'pre_breakfast', value: 'Pre Breakfast', selectedAndDisabled: false, beverageOptions: [], selectedBeverage: null },
    { key: 'breakfast', value: 'Breakfast', selectedAndDisabled: false, beverageOptions: [], selectedBeverage: null },
    { key: 'mid_morning', value: 'Mid Morning', selectedAndDisabled: false, },
    { key: 'lunch', value: 'Lunch', selectedAndDisabled: false, },
    { key: 'snacks', value: 'Snacks', selectedAndDisabled: false, },
    { key: 'mid_evening', value: 'Mid Evening', selectedAndDisabled: false, beverageOptions: [], selectedBeverage: null },
    { key: 'dinner', value: 'Dinner', selectedAndDisabled: false, },
    { key: 'bedtime', value: 'Bedtime', selectedAndDisabled: false, },
  ];

  public static readonly CARBOHYDRATE_ID: number = 33;
  public static readonly TOTAL_FAT_ID: number = 30;
  public static readonly PROTEIN_ID: number = 29;
  public static readonly ENERGY_ID: number = 34;
  public static readonly FIBER_ID: number = 32;
  public static readonly CALCIUM_ID: number = 35;
  public static readonly IRON_ID: number = 37;
  public static readonly VITAMIN_C_ID: number = 45;
  public static readonly SODIUM_ID: number = 48;
  public static readonly POTASSIUM_ID: number = 49;
  public static readonly ZINC_ID: number = 53;
  public static readonly VITAMIN_A_ID: number = 114;
  public static readonly FOLATE_ID: number = 44;
  public static readonly OMEGA_3_ID: number = 267;

  public static readonly MACRO_NUTRIENTS = [
    Constants.ENERGY_ID,
    Constants.CARBOHYDRATE_ID,
    Constants.PROTEIN_ID,
    Constants.TOTAL_FAT_ID,
    Constants.FIBER_ID,
  ];
  public static readonly MICRO_NUTRIENTS = [
    Constants.CALCIUM_ID,
    Constants.ZINC_ID,
    Constants.IRON_ID,
    Constants.POTASSIUM_ID,
    Constants.SODIUM_ID,
    Constants.VITAMIN_C_ID,
    Constants.OMEGA_3_ID,
    Constants.VITAMIN_A_ID,
    Constants.FOLATE_ID,
  ];
  public static readonly ALL_NUTRIENTS: any[] = [
    ...this.MACRO_NUTRIENTS,
    ...this.MICRO_NUTRIENTS,
  ];

  public static readonly NUTRIENTS_NAMES: any = {
    [Constants.CARBOHYDRATE_ID]: { name: 'Carbs', unit: 'g' },
    [Constants.TOTAL_FAT_ID]: { name: 'Fat', unit: 'g' },
    [Constants.PROTEIN_ID]: { name: 'Protein', unit: 'g' },
    [Constants.ENERGY_ID]: { name: 'Energy', unit: 'kcal' },
    [Constants.FIBER_ID]: { name: 'Fiber', unit: 'g' },
    [Constants.CALCIUM_ID]: { name: 'Calcium', unit: 'mg' },
    [Constants.IRON_ID]: { name: 'Iron (Fe)', unit: 'mg' },
    [Constants.VITAMIN_C_ID]: { name: 'Vitamin C', unit: 'mg' },
    [Constants.SODIUM_ID]: { name: 'Sodium', unit: 'mg' },
    [Constants.POTASSIUM_ID]: { name: 'Potassium', unit: 'mg' },
    [Constants.ZINC_ID]: { name: 'Zinc', unit: 'mg' },
    [Constants.VITAMIN_A_ID]: { name: 'Vitamin A', unit: 'mg' },
    [Constants.FOLATE_ID]: { name: 'Folate', unit: 'mg' },
    [Constants.OMEGA_3_ID]: { name: 'Omega 3', unit: 'mg' },
  };

  public static readonly HEALTH_SOURCE: any = {
    1: 'Google Fit',
    2: 'FitBit',
    3: 'Apple Health',
  };

  public static readonly TRACKERS: any = {
    1: 'Mood',
    // 2: 'Sleep',
    // 3: 'Habbit',
  };

  public static readonly CGMS_SENSORS: any[] = [
    { value: '3', name: 'Abbott Libre 1' },
    { value: '4', name: 'Abbott Libre Pro' },
    { value: '5', name: 'Dexcom' },
  ];

  public static readonly TIMEZONE_COUNTRY_NAME: any = {
    'Asia/Kolkata': 'India',
    'Asia/Dubai': 'United Arab Emirates',
    'America/New_York': 'United States',
    'America/Detroit': 'United States',
    'America/Kentucky/Louisville': 'United States',
    'America/Kentucky/Monticello': 'United States',
    'America/Indiana/Indianapolis': 'United States',
    'America/Indiana/Vincennes': 'United States',
    'America/Indiana/Winamac': 'United States',
    'America/Indiana/Marengo': 'United States',
    'America/Indiana/Petersburg': 'United States',
    'America/Indiana/Vevay': 'United States',
    'America/Chicago': 'United States',
    'America/Indiana/Tell_City': 'United States',
    'America/Indiana/Knox': 'United States',
    'America/Menominee': 'United States',
    'America/North_Dakota/Center': 'United States',
    'America/North_Dakota/New_Salem': 'United States',
    'America/North_Dakota/Beulah': 'United States',
    'America/Denver': 'United States',
    'America/Boise': 'United States',
    'America/Phoenix': 'United States',
    'America/Los_Angeles': 'United States',
    'America/Anchorage': 'United States',
    'America/Juneau': 'United States',
    'America/Sitka': 'United States',
    'America/Metlakatla': 'United States',
    'America/Yakutat': 'United States',
    'America/Nome': 'United States',
    'America/Adak': 'United States',
    'Pacific/Honolulu': 'United States',
    'America/Montevideo': 'Uruguay',
    'Asia/Samarkand': 'Uzbekistan',
    'Asia/Tashkent': 'Uzbekistan',
    'Europe/Vatican': 'Vatican City',
    'America/St_Vincent': 'St Vincent',
    'America/Caracas': 'Venezuela',
    'America/Tortola': 'Virgin Islands (UK)',
    'America/St_Thomas': 'Virgin Islands (US)',
    'Asia/Ho_Chi_Minh': 'Vietnam',
    'Pacific/Efate': 'Vanuatu',
    'Pacific/Wallis': 'Wallis & Futuna',
    'Pacific/Apia': 'Samoa (western)',
    'Asia/Aden': 'Yemen',
    'Indian/Mayotte': 'Mayotte',
    'Africa/Johannesburg': 'South Africa',
    'Africa/Lusaka': 'Zambia',
    'Africa/Harare': 'Zimbabwe',
    'America/Godthab': 'Greenland',
    'America/Montreal': 'Canada',
    'America/Santa_Isabel': 'Mexico',
    'Asia/Rangoon': 'Myanmar (Burma)',
    'Australia/Currie': 'Australia',
    'Canada/Atlantic': 'Canada',
    'Canada/Central': 'Canada',
    'Canada/Eastern': 'Canada',
    'Canada/Mountain': 'Canada',
    'Canada/Newfoundland': 'Canada',
    'Canada/Pacific': 'Canada',
    'Europe/Kiev': 'Ukraine',
    'Pacific/Enderbury': 'Kiribati',
    'Pacific/Johnston': 'United States',
    'US/Alaska': 'United States',
    'US/Arizona': 'United States',
    'US/Central': 'United States',
    'US/Eastern': 'United States',
    'US/Hawaii': 'United States',
    'US/Mountain': 'United States',
    'US/Pacific': 'United States',
    'America/St_Johns': 'Canada',
    'America/Halifax': 'Canada',
    'America/Glace_Bay': 'Canada',
    'America/Moncton': 'Canada',
    'America/Goose_Bay': 'Canada',
    'America/Blanc-Sablon': 'Canada',
    'America/Toronto': 'Canada',
    'America/Nipigon': 'Canada',
    'America/Thunder_Bay': 'Canada',
    'America/Iqaluit': 'Canada',
    'America/Pangnirtung': 'Canada',
    'America/Atikokan': 'Canada',
    'America/Winnipeg': 'Canada',
    'America/Rainy_River': 'Canada',
    'America/Resolute': 'Canada',
    'America/Rankin_Inlet': 'Canada',
    'America/Regina': 'Canada',
    'America/Swift_Current': 'Canada',
    'America/Edmonton': 'Canada',
    'America/Cambridge_Bay': 'Canada',
    'America/Yellowknife': 'Canada',
    'America/Inuvik': 'Canada',
    'America/Creston': 'Canada',
    'America/Dawson_Creek': 'Canada',
    'America/Fort_Nelson': 'Canada',
    'America/Whitehorse': 'Canada',
    'America/Dawson': 'Canada',
    'America/Vancouver': 'Canada',
    'Europe/Andorra': 'Andorra',
    'Asia/Kabul': 'Afghanistan',
    'America/Antigua': 'Antigua & Barbuda',
    'America/Anguilla': 'Anguilla',
    'Europe/Tirane': 'Albania',
    'Asia/Yerevan': 'Armenia',
    'Africa/Luanda': 'Angola',
    'Antarctica/McMurdo': 'Antarctica',
    'Antarctica/Casey': 'Antarctica',
    'Antarctica/Davis': 'Antarctica',
    'Antarctica/DumontDUrville': 'Antarctica',
    'Antarctica/Mawson': 'Antarctica',
    'Antarctica/Palmer': 'Antarctica',
    'Antarctica/Rothera': 'Antarctica',
    'Antarctica/Syowa': 'Antarctica',
    'Antarctica/Troll': 'Antarctica',
    'Antarctica/Vostok': 'Antarctica',
    'America/Argentina/Buenos_Aires': 'Argentina',
    'America/Argentina/Cordoba': 'Argentina',
    'America/Argentina/Salta': 'Argentina',
    'America/Argentina/Jujuy': 'Argentina',
    'America/Argentina/Tucuman': 'Argentina',
    'America/Argentina/Catamarca': 'Argentina',
    'America/Argentina/La_Rioja': 'Argentina',
    'America/Argentina/San_Juan': 'Argentina',
    'America/Argentina/Mendoza': 'Argentina',
    'America/Argentina/San_Luis': 'Argentina',
    'America/Argentina/Rio_Gallegos': 'Argentina',
    'America/Argentina/Ushuaia': 'Argentina',
    'Pacific/Pago_Pago': 'Samoa (American)',
    'Europe/Vienna': 'Austria',
    'Australia/Lord_Howe': 'Australia',
    'Antarctica/Macquarie': 'Australia',
    'Australia/Hobart': 'Australia',
    'Australia/Melbourne': 'Australia',
    'Australia/Sydney': 'Australia',
    'Australia/Broken_Hill': 'Australia',
    'Australia/Brisbane': 'Australia',
    'Australia/Lindeman': 'Australia',
    'Australia/Adelaide': 'Australia',
    'Australia/Darwin': 'Australia',
    'Australia/Perth': 'Australia',
    'Australia/Eucla': 'Australia',
    'America/Aruba': 'Aruba',
    'Europe/Mariehamn': 'Aaland Islands',
    'Asia/Baku': 'Azerbaijan',
    'Europe/Sarajevo': 'Bosnia & Herzegovina',
    'America/Barbados': 'Barbados',
    'Asia/Dhaka': 'Bangladesh',
    'Europe/Brussels': 'Belgium',
    'Africa/Ouagadougou': 'Burkina Faso',
    'Europe/Sofia': 'Bulgaria',
    'Asia/Bahrain': 'Bahrain',
    'Africa/Bujumbura': 'Burundi',
    'Africa/Porto-Novo': 'Benin',
    'America/St_Barthelemy': 'St Barthelemy',
    'Atlantic/Bermuda': 'Bermuda',
    'Asia/Brunei': 'Brunei',
    'America/La_Paz': 'Bolivia',
    'America/Kralendijk': 'Caribbean Netherlands',
    'America/Noronha': 'Brazil',
    'America/Belem': 'Brazil',
    'America/Fortaleza': 'Brazil',
    'America/Recife': 'Brazil',
    'America/Araguaina': 'Brazil',
    'America/Maceio': 'Brazil',
    'America/Bahia': 'Brazil',
    'America/Sao_Paulo': 'Brazil',
    'America/Campo_Grande': 'Brazil',
    'America/Cuiaba': 'Brazil',
    'America/Santarem': 'Brazil',
    'America/Porto_Velho': 'Brazil',
    'America/Boa_Vista': 'Brazil',
    'America/Manaus': 'Brazil',
    'America/Eirunepe': 'Brazil',
    'America/Rio_Branco': 'Brazil',
    'America/Nassau': 'Bahamas',
    'Asia/Thimphu': 'Bhutan',
    'Africa/Gaborone': 'Botswana',
    'Europe/Minsk': 'Belarus',
    'America/Belize': 'Belize',
    'Indian/Cocos': 'Cocos (Keeling) Islands',
    'Africa/Kinshasa': 'Congo (Dem. Rep.)',
    'Africa/Lubumbashi': 'Congo (Dem. Rep.)',
    'Africa/Bangui': 'Central African Rep.',
    'Africa/Brazzaville': 'Congo (Rep.)',
    'Europe/Zurich': 'Switzerland',
    'Africa/Abidjan': "Cote d'Ivoire",
    'Pacific/Rarotonga': 'Cook Islands',
    'America/Santiago': 'Chile',
    'America/Punta_Arenas': 'Chile',
    'Pacific/Easter': 'Chile',
    'Africa/Douala': 'Cameroon',
    'Asia/Shanghai': 'China',
    'Asia/Urumqi': 'China',
    'America/Bogota': 'Colombia',
    'America/Costa_Rica': 'Costa Rica',
    'America/Havana': 'Cuba',
    'Atlantic/Cape_Verde': 'Cape Verde',
    'America/Curacao': 'Curacao',
    'Indian/Christmas': 'Christmas Island',
    'Asia/Nicosia': 'Cyprus',
    'Asia/Famagusta': 'Cyprus',
    'Europe/Prague': 'Czech Republic',
    'Europe/Berlin': 'Germany',
    'Europe/Busingen': 'Germany',
    'Africa/Djibouti': 'Djibouti',
    'Europe/Copenhagen': 'Denmark',
    'America/Dominica': 'Dominica',
    'America/Santo_Domingo': 'Dominican Republic',
    'Africa/Algiers': 'Algeria',
    'America/Guayaquil': 'Ecuador',
    'Pacific/Galapagos': 'Ecuador',
    'Europe/Tallinn': 'Estonia',
    'Africa/Cairo': 'Egypt',
    'Africa/El_Aaiun': 'Western Sahara',
    'Africa/Asmara': 'Eritrea',
    'Europe/Madrid': 'Spain',
    'Africa/Ceuta': 'Spain',
    'Atlantic/Canary': 'Spain',
    'Africa/Addis_Ababa': 'Ethiopia',
    'Europe/Helsinki': 'Finland',
    'Pacific/Fiji': 'Fiji',
    'Atlantic/Stanley': 'Falkland Islands',
    'Pacific/Chuuk': 'Micronesia',
    'Pacific/Pohnpei': 'Micronesia',
    'Pacific/Kosrae': 'Micronesia',
    'Atlantic/Faroe': 'Faroe Islands',
    'Europe/Paris': 'France',
    'Africa/Libreville': 'Gabon',
    'Europe/London': 'Britain (UK)',
    'America/Grenada': 'Grenada',
    'Asia/Tbilisi': 'Georgia',
    'America/Cayenne': 'French Guiana',
    'Europe/Guernsey': 'Guernsey',
    'Africa/Accra': 'Ghana',
    'Europe/Gibraltar': 'Gibraltar',
    'America/Nuuk': 'Greenland',
    'America/Danmarkshavn': 'Greenland',
    'America/Scoresbysund': 'Greenland',
    'America/Thule': 'Greenland',
    'Africa/Banjul': 'Gambia',
    'Africa/Conakry': 'Guinea',
    'America/Guadeloupe': 'Guadeloupe',
    'Africa/Malabo': 'Equatorial Guinea',
    'Europe/Athens': 'Greece',
    'Atlantic/South_Georgia': 'South Georgia & the South Sandwich Islands',
    'America/Guatemala': 'Guatemala',
    'Pacific/Guam': 'Guam',
    'Africa/Bissau': 'Guinea-Bissau',
    'America/Guyana': 'Guyana',
    'Asia/Hong_Kong': 'Hong Kong',
    'America/Tegucigalpa': 'Honduras',
    'Europe/Zagreb': 'Croatia',
    'America/Port-Australia-Prince': 'Haiti',
    'Europe/Budapest': 'Hungary',
    'Asia/Jakarta': 'Indonesia',
    'Asia/Pontianak': 'Indonesia',
    'Asia/Makassar': 'Indonesia',
    'Asia/Jayapura': 'Indonesia',
    'Europe/Dublin': 'Ireland',
    'Asia/Jerusalem': 'Israel',
    'Europe/Isle_of_Man': 'Isle of Man',
    'Asia/Calcutta': 'India',
    'Indian/Chagos': 'British Indian Ocean Territory',
    'Asia/Baghdad': 'Iraq',
    'Asia/Tehran': 'Iran',
    'Atlantic/Reykjavik': 'Iceland',
    'Europe/Rome': 'Italy',
    'Europe/Jersey': 'Jersey',
    'America/Jamaica': 'Jamaica',
    'Asia/Amman': 'Jordan',
    'Asia/Tokyo': 'Japan',
    'Africa/Nairobi': 'Kenya',
    'Asia/Bishkek': 'Kyrgyzstan',
    'Asia/Phnom_Penh': 'Cambodia',
    'Pacific/Tarawa': 'Kiribati',
    'Pacific/Kanton': 'Kiribati',
    'Pacific/Kiritimati': 'Kiribati',
    'Indian/Comoro': 'Comoros',
    'America/St_Kitts': 'St Kitts & Nevis',
    'Asia/Pyongyang': 'Korea (North)',
    'Asia/Seoul': 'Korea (South)',
    'Asia/Kuwait': 'Kuwait',
    'America/Cayman': 'Cayman Islands',
    'Asia/Almaty': 'Kazakhstan',
    'Asia/Qyzylorda': 'Kazakhstan',
    'Asia/Qostanay': 'Kazakhstan',
    'Asia/Aqtobe': 'Kazakhstan',
    'Asia/Aqtau': 'Kazakhstan',
    'Asia/Atyrau': 'Kazakhstan',
    'Asia/Oral': 'Kazakhstan',
    'Asia/Vientiane': 'Laos',
    'Asia/Beirut': 'Lebanon',
    'America/St_Lucia': 'St Lucia',
    'Europe/Vaduz': 'Liechtenstein',
    'Asia/Colombo': 'Sri Lanka',
    'Africa/Monrovia': 'Liberia',
    'Africa/Maseru': 'Lesotho',
    'Europe/Vilnius': 'Lithuania',
    'Europe/Luxembourg': 'Luxembourg',
    'Europe/Riga': 'Latvia',
    'Africa/Tripoli': 'Libya',
    'Africa/Casablanca': 'Morocco',
    'Europe/Monaco': 'Monaco',
    'Europe/Chisinau': 'Moldova',
    'Europe/Podgorica': 'Montenegro',
    'America/Marigot': 'St Martin (French part)',
    'Indian/Antananarivo': 'Madagascar',
    'Pacific/Majuro': 'Marshall Islands',
    'Pacific/Kwajalein': 'Marshall Islands',
    'Europe/Skopje': 'Macedonia',
    'Africa/Bamako': 'Mali',
    'Asia/Yangon': 'Myanmar (Burma)',
    'Asia/Ulaanbaatar': 'Mongolia',
    'Asia/Hovd': 'Mongolia',
    'Asia/Choibalsan': 'Mongolia',
    'Asia/Macau': 'Macau',
    'Pacific/Saipan': 'Northern Mariana Islands',
    'America/Martinique': 'Martinique',
    'Africa/Nouakchott': 'Mauritania',
    'America/Montserrat': 'Montserrat',
    'Europe/Malta': 'Malta',
    'Indian/Mauritius': 'Mauritius',
    'Indian/Maldives': 'Maldives',
    'Africa/Blantyre': 'Malawi',
    'America/Mexico_City': 'Mexico',
    'America/Cancun': 'Mexico',
    'America/Merida': 'Mexico',
    'America/Monterrey': 'Mexico',
    'America/Matamoros': 'Mexico',
    'America/Mazatlan': 'Mexico',
    'America/Chihuahua': 'Mexico',
    'America/Ojinaga': 'Mexico',
    'America/Hermosillo': 'Mexico',
    'America/Tijuana': 'Mexico',
    'America/Bahia_Banderas': 'Mexico',
    'Asia/Kuala_Lumpur': 'Malaysia',
    'Asia/Kuching': 'Malaysia',
    'Africa/Maputo': 'Mozambique',
    'Africa/Windhoek': 'Namibia',
    'Pacific/Noumea': 'New Caledonia',
    'Africa/Niamey': 'Niger',
    'Pacific/Norfolk': 'Norfolk Island',
    'Africa/Lagos': 'Nigeria',
    'America/Managua': 'Nicaragua',
    'Europe/Amsterdam': 'Netherlands',
    'Europe/Oslo': 'Norway',
    'Asia/Kathmandu': 'Nepal',
    'Pacific/Nauru': 'Nauru',
    'Pacific/Niue': 'Niue',
    'Pacific/Auckland': 'New Zealand',
    'Pacific/Chatham': 'New Zealand',
    'Asia/Muscat': 'Oman',
    'America/Panama': 'Panama',
    'America/Lima': 'Peru',
    'Pacific/Tahiti': 'French Polynesia',
    'Pacific/Marquesas': 'French Polynesia',
    'Pacific/Gambier': 'French Polynesia',
    'Pacific/Port_Moresby': 'Papua New Guinea',
    'Pacific/Bougainville': 'Papua New Guinea',
    'Asia/Manila': 'Philippines',
    'Asia/Karachi': 'Pakistan',
    'Europe/Warsaw': 'Poland',
    'America/Miquelon': 'St Pierre & Miquelon',
    'Pacific/Pitcairn': 'Pitcairn',
    'America/Puerto_Rico': 'Puerto Rico',
    'Asia/Gaza': 'Palestine',
    'Asia/Hebron': 'Palestine',
    'Europe/Lisbon': 'Portugal',
    'Atlantic/Madeira': 'Portugal',
    'Atlantic/Azores': 'Portugal',
    'Pacific/Palau': 'Palau',
    'America/Asuncion': 'Paraguay',
    'Asia/Qatar': 'Qatar',
    'Indian/Reunion': 'Reunion',
    'Europe/Bucharest': 'Romania',
    'Europe/Belgrade': 'Serbia',
    'Europe/Kaliningrad': 'Russia',
    'Europe/Moscow': 'Russia',
    'Europe/Simferopol': 'Ukraine',
    'Europe/Kirov': 'Russia',
    'Europe/Volgograd': 'Russia',
    'Europe/Astrakhan': 'Russia',
    'Europe/Saratov': 'Russia',
    'Europe/Ulyanovsk': 'Russia',
    'Europe/Samara': 'Russia',
    'Asia/Yekaterinburg': 'Russia',
    'Asia/Omsk': 'Russia',
    'Asia/Novosibirsk': 'Russia',
    'Asia/Barnaul': 'Russia',
    'Asia/Tomsk': 'Russia',
    'Asia/Novokuznetsk': 'Russia',
    'Asia/Krasnoyarsk': 'Russia',
    'Asia/Irkutsk': 'Russia',
    'Asia/Chita': 'Russia',
    'Asia/Yakutsk': 'Russia',
    'Asia/Khandyga': 'Russia',
    'Asia/Vladivostok': 'Russia',
    'Asia/Ust-Nera': 'Russia',
    'Asia/Magadan': 'Russia',
    'Asia/Sakhalin': 'Russia',
    'Asia/Srednekolymsk': 'Russia',
    'Asia/Kamchatka': 'Russia',
    'Asia/Anadyr': 'Russia',
    'Africa/Kigali': 'Rwanda',
    'Asia/Riyadh': 'Saudi Arabia',
    'Pacific/Guadalcanal': 'Solomon Islands',
    'Indian/Mahe': 'Seychelles',
    'Africa/Khartoum': 'Sudan',
    'Europe/Stockholm': 'Sweden',
    'Asia/Singapore': 'Singapore',
    'Atlantic/St_Helena': 'St Helena',
    'Europe/Ljubljana': 'Slovenia',
    'Arctic/Longyearbyen': 'Svalbard & Jan Mayen',
    'Europe/Bratislava': 'Slovakia',
    'Africa/Freetown': 'Sierra Leone',
    'Europe/San_Marino': 'San Marino',
    'Africa/Dakar': 'Senegal',
    'Africa/Mogadishu': 'Somalia',
    'America/Paramaribo': 'Suriname',
    'Africa/Juba': 'South Sudan',
    'Africa/Sao_Tome': 'Sao Tome & Principe',
    'America/El_Salvador': 'El Salvador',
    'America/Lower_Princes': 'St Maarten (Dutch part)',
    'Asia/Damascus': 'Syria',
    'Africa/Mbabane': 'Swaziland',
    'America/Grand_Turk': 'Turks & Caicos Is',
    'Africa/Ndjamena': 'Chad',
    'Indian/Kerguelen': 'French Southern & Antarctic Lands',
    'Africa/Lome': 'Togo',
    'Asia/Bangkok': 'Thailand',
    'Asia/Dushanbe': 'Tajikistan',
    'Pacific/Fakaofo': 'Tokelau',
    'Asia/Dili': 'East Timor',
    'Asia/Ashgabat': 'Turkmenistan',
    'Africa/Tunis': 'Tunisia',
    'Pacific/Tongatapu': 'Tonga',
    'Europe/Istanbul': 'Turkey',
    'America/Port_of_Spain': 'Trinidad & Tobago',
    'Pacific/Funafuti': 'Tuvalu',
    'Asia/Taipei': 'Taiwan',
    'Africa/Dar_es_Salaam': 'Tanzania',
    'Europe/Kyiv': 'Ukraine',
    'Europe/Uzhgorod': 'Ukraine',
    'Europe/Zaporozhye': 'Ukraine',
    'Africa/Kampala': 'Uganda',
    'Pacific/Midway': 'US minor outlying islands',
    'Pacific/Wake': 'US minor outlying islands',
  };

  public static readonly IVR_LOCATION_MAIN_TASKS: string = 'main-tasks';
  public static readonly IVR_LOCATION_MEMBER_TASKS: string = 'member-tasks';
  public static readonly IVR_LOCATION_OUTBOUND_CALL: string = 'outbound-call';
  public static readonly IVR_LOCATION_LEAD_CALL: string = 'lead-call';

  public static readonly MEMBER_GS_TABS: any[] = [
    { label: 'Sessions Till Date' },
    { label: 'Sessions Subscribed' },
    { label: 'Recommended Sessions' },
  ];

  public static readonly PROGRAM_NAMES: any = {
    "DIABEFLY_PRIME": 26,
    "DIABEFLY_PRIME_2_0": 58
  };

  public static readonly DEPARTMENTS: any = {
    1: 'CSE',
    2: 'Nutritionist',
    3: 'Care Manager',
    4: 'Physiotherapy',
    5: 'Psychology',
    6: 'Program design',
    7: 'Medico Marketing',
    8: 'Tech',
    9: 'Product',
    10: 'Operations',
    11: 'HR',
    12: 'Accounts',
    13: 'Content',
    14: 'Other',
  };

  public static readonly DEPARTMENT_CATEGORY: any = {
    'Coach': [2, 4, 5],
    'Member Support Executive': [3],
  };

  public static readonly SMBG_TYPES: any = {
    fasting: "Fasting",
    postBreakfast: "Post Breakfast",
    preLunch: "Pre Lunch",
    postLunch: "Post Lunch",
    preDinner: "Pre Dinner",
    postDinner: "Post Dinner",
    am3: "3 AM",
    random: "Random",
  }

  // Investigation Sub types - Lipid Profile, Liver Function and Kidney Function
  public static readonly INVESTIGATION_SUB_TYPES: any = {
    smbg: [
      { key: 'fasting', name: 'Fasting' },
      { key: 'postBreakfast', name: 'Post Breakfast' },
      { key: 'preLunch', name: 'Pre Lunch' },
      { key: 'postLunch', name: 'Post Lunch' },
      { key: 'preDinner', name: 'Pre Dinner' },
      { key: 'postDinner', name: 'Post Dinner' },
      { key: 'am3', name: '3 AM' },
      { key: 'random', name: 'Random' },
      { key: 'untagged_reading', name: 'Untagged Reading' },
    ],
    lipid_profile: [
      {
        key: 'TTLC',
        value: 'Total Cholesterol',
        unit: 'mg/dl',
        min: 70,
        max: 500,
      },
      {
        key: 'LDL',
        value: 'LDL Cholesterol',
        unit: 'mg/dl',
        min: 20,
        max: 250,
      },
      {
        key: 'VLDL',
        value: 'VLDL Cholesterol',
        unit: 'mg/dl',
        min: 0,
        max: 150,
      },
      {
        key: 'HDL',
        value: 'HDL Cholesterol',
        unit: 'mg/dl',
        min: 20,
        max: 100,
      },
      {
        key: 'TRGLD',
        value: 'Triglycerides',
        unit: 'mg/dl',
        min: 50,
        max: 3000,
      },
    ],
    liver_function: [
      {
        key: 'TTLBLRB',
        value: 'Total Bilirubin',
        unit: 'mg/dl',
        min: 0.01,
        max: 50,
      },
      { key: 'SGOT', value: 'SGOT', unit: 'IU/L', min: 5, max: 1000 },
      { key: 'SGPT', value: 'SGPT', unit: 'IU/L', min: 5, max: 1000 },
      {
        key: 'ALP',
        value: 'Alkaline Phosphatase',
        unit: 'IU/L',
        min: 5,
        max: 5000,
      },
      { key: 'SRAL', value: 'Sr. Albumin', unit: 'gm/dl', min: 1.5, max: 10 },
      { key: 'SRGL', value: 'Sr. Globulin', unit: 'gm/dl', min: 1.5, max: 10 },
      { key: 'GGT', value: 'Gamma GT', unit: 'gm/dl', min: 0, max: 300 },
    ],
    kidney_function: [
      {
        key: 'SRCRTN',
        value: 'Sr Creatinine',
        unit: 'gm/dl',
        min: 0.3,
        max: 30,
      },
      { key: 'SRUREA', value: 'Sr Urea', unit: 'gm/dl', min: 5, max: 200 },
      { key: 'SRNA', value: 'Sr Sodium', unit: 'mmol/l', min: 100, max: 180 },
      { key: 'SRK', value: 'Sr Potassium', unit: 'mmol/l', min: 1, max: 15 },
      { key: 'SRCL', value: 'Sr Chloride', unit: 'mmol/l', min: 50, max: 150 },
      { key: 'BICNT', value: 'Bicarbonate', unit: 'mmol/l', min: 5, max: 100 },
      {
        key: 'SRURICACID',
        value: 'Sr Uric acid',
        unit: 'mg/dl',
        min: 1,
        max: 30,
      },
      { key: 'AG', value: 'Anion Gap', unit: 'mmol/l', min: 1, max: 50 },
    ],
  };

  // Interpretation of values - Lipid Profile, Liver Function and Kidney Function
  public static readonly INVESTIGATION_INTERPRETATIONS: any = {
    'Low blood sugar': 'low',
    Normal: 'normal',
    'Pre diabetes': 'borderline-high',
    Prediabetes: 'borderline-high',
    'Pre-diabetes': 'borderline-high',
    Diabetes: 'high',
    'High Sugar': 'high',
    'High blood sugar': 'high',
    High: 'high',
    'Very High': 'high',
    Low: 'low',
    'Near Optimal': 'borderline-high',
    'Borderline high': 'borderline-high',
  };
  public static readonly KEY_OBSERVATION_TABS: any[] = [{ label: 'Nutrition' }];

  public static readonly NUTRITION_COLUMNS: string[] = [
    'Nutrition Name',
    'RDA',
    'Avg. Consumed',
    'Percentage Deviation',
    // '% Devn. from Range',
    'Range',
  ];

  public static readonly AGM_COLUMNS: string[] = ['Observation Type', 'Data'];

  public static readonly SESSION_STATUSES: any[] = [
    {
      name: 'Upcoming',
      value: 'upcoming',
    },
    {
      name: 'Completed',
      value: 'completed',
    },
  ];

  public static readonly RECORDING_STATUS_FILTERS: any[] = [
    {
      name: 'Recording Uploaded',
      value: 'true'
    },
    {
      name: 'Recording Pending',
      value: 'false'
    },
  ];

  public static readonly EVENT_ADMIN_TYPES: any[] = [
    {
      name: 'Group Sessions',
      value: 'group_sessions',
    },
    {
      name: 'Cohorts',
      value: 'cohorts',
    },
  ];

  public static readonly EA_CANNOT_UPDATE_MESSAGE: string =
    'Event Admin can not update Archive and Completed Sessions!';

  public static readonly MEDICAL_REPORT_TYPES: {key: string, name: string}[] = [
    { key: 'agm', name: 'AGM' },
    { key: 'prescription', name: 'Prescription' },
    { key: 'lab-report', name: 'Lab Investigation Report' },
    { key: 'others', name: 'Others' },
  ];

  public static readonly GOALS_TABS: any[] = [
    { label: 'Nutrition', id: 1 },
    { label: 'Physiotherapy', id: 2 },
    { label: 'Psychology', id: 3 },
  ];

  public static readonly BASELINE_RANGES: any = {
    1: [
      {
        from: null,
        to: 6.5,
        suggested_meo_value: null,
        operation: '',
      },
      {
        from: 6.5,
        to: 7,
        suggested_meo_value: 0.5,
        operation: '-',
      },
      {
        from: 7,
        to: 8,
        suggested_meo_value: 1,
        operation: '-',
      },
      {
        from: 8,
        to: 10,
        suggested_meo_value: 1.5,
        operation: '-',
      },
      {
        from: 10,
        to: 12,
        suggested_meo_value: 2,
        operation: '-',
      },
      {
        from: 12,
        to: 14,
        suggested_meo_value: 3,
        operation: '-',
      },
      {
        from: 14,
        to: null,
        suggested_meo_value: 5,
        operation: '-',
      },
    ],
    4: [
      {
        from: null,
        to: 130,
        suggested_meo_value: null,
        operation: '',
      },
      {
        from: 130,
        to: null,
        suggested_meo_value: 130,
        operation: '',
      },
    ],
    5: [
      {
        from: null,
        to: 180,
        suggested_meo_value: null,
        operation: '',
      },
      {
        from: 180,
        to: null,
        suggested_meo_value: 180,
        operation: '',
      },
    ],
    11: [
      {
        from: null,
        to: 100,
        suggested_meo_value: null,
        operation: '',
      },
      {
        from: 100,
        to: null,
        suggested_meo_value: 100,
        operation: '',
      },
    ],
    12: [
      {
        from: null,
        to: 150,
        suggested_meo_value: null,
        operation: '',
      },
      {
        from: 150,
        to: null,
        suggested_meo_value: 150,
        operation: '',
      },
    ],
    13: [
      {
        from: null,
        to: 18,
        suggested_meo_value: null,
        operation: '',
      },
      {
        from: 18,
        to: 23,
        suggested_meo_value: null,
        operation: '',
      },
      {
        from: 23,
        to: 27.5,
        suggested_meo_value: 98,
        operation: '%',
      },
      {
        from: 27.5,
        to: 32.5,
        suggested_meo_value: 95,
        operation: '%',
      },
      {
        from: 32.5,
        to: 37.5,
        suggested_meo_value: 95,
        operation: '%',
      },
      {
        from: 37.5,
        to: 100,
        suggested_meo_value: 95,
        operation: '%',
      },
      {
        from: 100,
        to: null,
        suggested_meo_value: 95,
        operation: '%',
      },
    ],
    14: [
      {
        from: -1000,
        to: null,
        suggested_meo_value: 150,
        operation: '%',
      },
    ],
    15: [
      {
        from: -1000,
        to: null,
        suggested_meo_value: 150,
        operation: '%',
      },
    ],
    16: [
      {
        from: -1000,
        to: null,
        suggested_meo_value: 150,
        operation: '%',
      },
    ],
    17: [
      {
        from: -1000,
        to: null,
        suggested_meo_value: 150,
        operation: '%',
      },
    ],
    18: [
      {
        from: -1000,
        to: null,
        suggested_meo_value: 110,
        operation: '%',
      },
    ],
    19: [
      {
        from: -1000,
        to: null,
        suggested_meo_value: 50,
        operation: '%',
      },
    ],
  };
  public static readonly ANTHROPOMETRY_TABS: any[] = [
    { label: 'Weight / Height' },
    { label: 'Waist / Hip' },
  ];

  public static readonly FITNESS_TABS: any[] = [
    { label: 'Activity Diary' },
    { label: 'Step Count' },
  ];

  public static readonly DEVICE_LIST: any[] = [
    {
      label: 'Apple Health',
      value: 'applehealth',
      icon: '../assets/images/appleHealth.svg',
    },
    {
      label: 'Goggle Fit',
      value: 'google',
      icon: '../assets/images/googleFit.svg',
    },
    { label: 'Fitbit', value: 'fitbit', icon: '../assets/images/fitbit.svg' },
    { label: 'Manual', value: 'manual' },
  ];

  public static readonly DEFAULT_GOALS: any = {
    'sedentary-or-less-active': [
      2500, 2500, 3500, 5000, 6000, 7000, 8000, 10000, 10000, 10000, 10000,
      10000,
    ],
    'moderately-active': [
      6000, 7000, 8000, 10000, 10000, 10000, 10000, 11000, 12000, 13000, 14000,
      15000,
    ],
    'highly-active': [
      6000, 7000, 8000, 10000, 10000, 10000, 10000, 11000, 12000, 13000, 14000,
      15000,
    ],
    'sports-active': [
      7500, 7500, 8500, 9500, 10500, 10500, 11500, 12500, 12500, 12500, 12500,
      12500,
    ],
  };

  public static readonly DIET_PLAN_PUBLISHED: number = 1;
  public static readonly DIET_PLAN_DRAFT: number = 2;
  public static readonly DIET_PLAN_DISCARDED: number = 3;

  public static readonly PATIENT_TYPES: any = {
    VVIP: {
      value: 'VVIP',
    },
    Retained: {
      value: 'Retained',
    },
    Escalated: {
      value: 'Escalated',
    },
    Actual: {
      value: 'Actual',
    },
    TEST: {
      value: 'TEST',
    },
  };

  public static readonly TASK_PRIORITIES: { id: number; name: string }[] = [
    { id: 1, name: 'Urgent' },
    { id: 2, name: 'Very High' },
    { id: 3, name: 'High' },
    { id: 4, name: 'Medium' },
    { id: 5, name: 'Low' },
  ];

  public static readonly TASKS_COUNTS_PER_STATUSES: any = {
    [Constants.TASK_STATUS_PENDING]: {
      key: 'Pending',
      id: Constants.TASK_STATUS_PENDING,
      count: 0,
    },
    [Constants.TASK_STATUS_IN_PROGRESS]: {
      key: 'In Progress',
      id: Constants.TASK_STATUS_IN_PROGRESS,
      count: 0,
    },
    [Constants.TASK_STATUS_RESCHEDULED]: {
      key: 'Rescheduled',
      id: Constants.TASK_STATUS_RESCHEDULED,
      count: 0,
    },
    [Constants.TASK_STATUS_DISCARDED]: {
      key: 'Discarded',
      id: Constants.TASK_STATUS_DISCARDED,
      count: 0,
    },
    [Constants.TASK_STATUS_COMPLETED]: {
      key: 'Completed',
      id: Constants.TASK_STATUS_COMPLETED,
      count: 0,
    },
    [Constants.TASK_STATUS_EXPIRED]: {
      key: 'Expired/Lapsed',
      id: Constants.TASK_STATUS_EXPIRED,
      count: 0,
    },
  };

  public static readonly ASSESSMNENT_TASK_STATUSES: any = {
    1: {
      id: 1,
      name: 'Pending',
    },
    3: {
      id: 3,
      name: 'In Progress',
    },
    5: {
      id: 5,
      name: 'Completed',
    },
    6: {
      key: 6,
      name: 'Discarded',
    },
    9: {
      key: 9,
      name: 'Suspended',
    },
    10: {
      key: 10,
      name: 'Archived',
    },
    13: {
      key: 13,
      name: 'Skipped'
    },
    14: {
      key: 14,
      name: 'Expired'
    }
  }

  public static readonly TASK_STATUSES: number[] = [
    Constants.TASK_STATUS_PENDING,
    Constants.TASK_STATUS_IN_PROGRESS,
    Constants.TASK_STATUS_RESCHEDULED,
    Constants.TASK_STATUS_DISCARDED,
    Constants.TASK_STATUS_COMPLETED,
    Constants.TASK_STATUS_EXPIRED,
    Constants.TASK_STATUS_EXPIRED,
  ];

  public static readonly PATIENT_OUTCOME_INTERPRETATION_PENDING: number = 0;
  public static readonly PATIENT_OUTCOME_INTERPRETATION_REVIEWED: number = 1;
  public static readonly PATIENT_OUTCOME_INTERPRETATION_EXPIRED: number = 2;

  public static readonly PATIENT_OUTCOME_INTERPRETATION_STATUSES: any = {
    PATIENT_OUTCOME_INTERPRETATION_PENDING: 'Pending',
    PATIENT_OUTCOME_INTERPRETATION_REVIEWED: 'Reviwed',
    PATIENT_OUTCOME_INTERPRETATION_EXPIRED: 'Expired',
  };

  /* Member Overview - Program Details */
  public static readonly PROGRAM_NOT_STARTED_REASONS: { name: string }[] = [
    { name: 'App Installed -- If App Installed Then Mention Date' },
    { name: 'Awaiting App Installation Schedule' },
    { name: 'Awaiting Program Start Schedule From Member' },
    { name: 'Call Back For App Installation' },
    { name: 'Call Back For Program Start' },
    { name: 'Future App Installation Date Is Provided' },
    { name: 'Future Start Date Is Provided' },
    { name: 'IAC Is Scheduled' },
    {
      name: 'Kit Is In Transit Again Due To Missing/Different Starter Kit',
    },
    { name: 'Kit Is In Transit Again Due To Faulty Instrument' },
    { name: 'Kit Is In Transit' },
    { name: 'Lead Not Consented For App Install' },
    { name: 'Lead Not Visible For App Install' },
    { name: 'Lead Not Consented For Program Start' },
    { name: 'Lead Not Visible For Program Start' },
    {
      name: 'Member Ask For Refund But Team Is Trying To Retain The Member',
    },
    { name: 'Member Discontinued The Program' },
    { name: 'Member Opted Refund' },
    { name: 'Other/Unknown' },
    { name: 'Program Started--If Program Started Then Mentioned Date' },
    { name: 'Reader Is In Transit' },
    { name: 'RNR For App Installation' },
    { name: 'RNR For Program Start' },
    { name: 'Sensor Application Scheduled' },
    { name: 'Sensor Dislodge/ Replacement' },
    { name: 'Suspended (RNR 7)' },
    { name: 'Suspended Reader Not Returned' },
    { name: 'Program lapse email sent' },
    { name: 'Email sent to client SPOC for program not start' },
    { name: 'Reenrollment -- previous program is ongoing' },
  ];

  // ? Investigation Sources
  public static readonly INVESTIGATION_SOURCE_LAB: string = "Lab"
  public static readonly INVESTIGATION_SOURCE_LAB_OPD_BENEFIT: string = "LabOPDBenefit"
  public static readonly INVESTIGATION_SOURCE_CUSTOMER_DECLARED: string = "CustomerDeclared"
  public static readonly INVESTIGATION_SOURCE_GLUCOMETER: string = "Glucometer"
  public static readonly INVESTIGATION_SOURCE_GLUCOMETER_AUTO: string = "GlucometerAuto"

  public static readonly INVESTIGATION_SOURCES: {key: string, name: string}[] = [
    { key: `${Constants.INVESTIGATION_SOURCE_LAB}`, name: "Lab / Lab (Reports, Partner Integrations)" },
    { key: `${Constants.INVESTIGATION_SOURCE_LAB_OPD_BENEFIT}`, name: "Lab (OPD Benefit)" },
    { key: `${Constants.INVESTIGATION_SOURCE_CUSTOMER_DECLARED}`, name: "Customer Declared" },
  ];

  public static readonly SMBG_SOURCES: {key: string, name: string}[] = [
    ...Constants.INVESTIGATION_SOURCES,
    { key: `${Constants.INVESTIGATION_SOURCE_GLUCOMETER}`, name: "Glucometer - Manual" },
    { key: `${Constants.INVESTIGATION_SOURCE_GLUCOMETER_AUTO}`, name: "Glucometer - Auto" },
  ];

  public static readonly MEAL_SLOTS: any = {
    pre_breakfast: {
      name: "Pre Breakfast",
      time_in_minutes: 390,
      start: 180,
      end: 390,
    },
    breakfast: {
      name: "Breakfast",
      time_in_minutes: 450,
      start: 390,
      end: 540,
    },
    mid_morning: {
      name: "Mid Morning",
      time_in_minutes: 600,
      start: 540,
      end: 690,
    },
    lunch: {
      name: "Lunch",
      time_in_minutes: 750,
      start: 690,
      end: 900,
    },
    snacks: {
      name: "Snacks",
      time_in_minutes: 930,
      start: 900,
      end: 1020,
    },
    mid_evening: {
      name: "Mid Evening",
      time_in_minutes: 1050,
      start: 1020,
      end: 1140,
    },
    dinner: {
      name: "Dinner",
      time_in_minutes: 1170,
      start: 1140,
      end: 1260,
    },
    bedtime: {
      name: "Bedtime",
      time_in_minutes: 1290,
      start: 1260,
      end: 1620,
    }
  }

  public static readonly NOTIFICATION_STATUS_READ: number = 1;
  public static readonly NOTIFICATION_STATUS_UNREAD: number = 2;
  public static readonly NOTIFICATION_STATUS_DISABLED: number = 3;

  // ? Coach Notification <> Statuses
  public static readonly NOTIFICATION_STATUSES: any = [
    { key: `${Constants.NOTIFICATION_STATUS_READ}`, name: "Read" },
    { key: `${Constants.NOTIFICATION_STATUS_UNREAD}`, name: "Un read" },
    { key: `${Constants.NOTIFICATION_STATUS_DISABLED}`, name: "Disabled" },
  ];

  public static readonly HEALTH_SOURCE_GOOGLE_FIT = 1;
  public static readonly HEALTH_SOURCE_FITBIT = 2;
  public static readonly HEALTH_SOURCE_APPLE_HEALTH = 3;

  public static readonly INVESTIGATION_TABS: any[] = [
    { label: 'SMBG', key: 'BloodGlucose' },
    { label: 'HbA1C', key: 'hba1c' },
    { label: 'Lipid Profile', key: 'lipid_profile', group: 'Lipid Profile' },
    { label: 'Liver Function', key: 'liver_function', group: 'Liver Function' },
    { label: 'Kidney Function', key: 'kidney_function', group: 'Kidney Function' },
  ];

  public static readonly HOLD_REASONS: any[] = [
    { name: "Travel" },
    { name: "Injury or illness" },
    { name: "Program related issues" },
    { name: "Busy work schedule" },
    { name: "Others" }
  ];
  public static readonly SUPPORT_TICKET_STATUSES: any = {
    1: {
      id: 1,
      label: "Open",
      class: "open",
      key: "open",
    },
    2: {
      id: 2,
      label: "In Progress",
      class: "in-progress",
      key: "in-progress",
    },
    3: {
      id: 3,
      label: "On Hold",
      class: "on-hold",
      key: "on-hold",
    },
    4: {
      id: 4,
      label: "Escalated",
      class: "escalated",
      key: "escalated",
    },
    5: {
      id: 5,
      label: "Resolved",
      class: "resolved",
      key: "resolved",
    },
    6: {
      id: 6,
      label: "Closed - with confirmation",
      class: "closed-with-confirmation",
      key: "closed-with-confirmation",
    },
    7: {
      id: 7,
      label: "Closed - pending confirmation",
      class: "closed-pending-confirmation",
      key: "closed-pending-confirmation",
    },
    8: {
      id: 8,
      label: "Under Tech Review",
      class: "under-tech-review",
      key: "under-tech-review",
    },
    9: {
      id: 9,
      label: "Duplicate",
      class: "duplicate",
      key: "duplicate",
    }
  };

  public static readonly THREAD_TYPE_MEMBER: string = 'member';
  public static readonly THREAD_TYPE_INTERNAL: string = 'internal';

  public static readonly REPLY_OPTIONS: any[] = [
    {
      id: 1,
      btnLabel: "Reply Internal",
      label: "Internal",
      key: Constants.THREAD_TYPE_INTERNAL,
    },
    {
      id: 2,
      btnLabel: "Reply Member",
      label: "Member",
      key: Constants.THREAD_TYPE_MEMBER,
    },
  ];

  public static readonly THREAD_TYPES: any = {
    1: {
      id: 1,
      name: "Internal",
      key: Constants.THREAD_TYPE_INTERNAL,
    },
    2: {
      id: 2,
      name: "Member",
      key: Constants.THREAD_TYPE_MEMBER,
    },
  };

  public static readonly SUPPORT_TICKET_PRIORITIES: any = {
    1: {
      id: 1,
      name: "High",
      value: "high",
    },
    2: {
      id: 2,
      name: "Medium",
      value: "medium",
    },
    3: {
      id: 3,
      name: "Low",
      value: "low",
    }
  };

  public static readonly SUPPORT_TICKET_CLASSIFICATIONS: any = {
    1: {
      id: 1,
      name: "Support",
    },
    2: {
      id: 2,
      name: "Concern",
    }
  };

  public static readonly FILE_TYPES: any = {
    'pdf': 'application/pdf',
    'jpeg': 'image/jpeg',
    'jpg': 'image/jpeg',
    'png': 'image/png',
    'mp4': 'video/mp4',
    'mov': 'video/quicktime',
    'mp3': 'audio/mpeg',
    'wav': 'audio/wav',
    'ogg': 'audio/ogg',
    'm4a': 'audio/mp4',
  };

  public static readonly ROLES: any = {
    [Constants.CARE_MANAGER_ROLE]: "Care Manager / Member Support Executive",
    [Constants.CARE_MANAGER_TEAM_LEAD_ROLE]: "Care Manager Team Lead / Member Support Executive Team Lead",
    [Constants.NUTRITION_COACH_ROLE]: "Nutrition Coach",
    [Constants.NUTRITION_COACH_TEAM_LEAD_ROLE]: "Nutrition Coach Team Lead",
    [Constants.PHYSIOTHERAPIST_COACH_ROLE]: "Physiotherapy Coach",
    [Constants.PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE]: "Physiotherapy Coach Team Lead",
    [Constants.PSYCHOLOGIST_COACH_ROLE]: "Success Coach",
    [Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE]: "Success Coach Team Lead",
  };

  // RECOMMEND
  public static readonly RECOMMEND_STATUSES: any = {
    1: {
      id: 1,
      label: "Paid",
      class: "paid",
      key: "paid",
    },
    2: {
      id: 2,
      label: "Failed",
      class: "failed",
      key: "failed",
    },
    3: {
      id: 3,
      label: "Pending",
      class: "pending",
      key: "pending",
    },
    4: {
      id: 4,
      label: "Expired",
      class: "expired",
      key: "expired",
    },
  }

  public static readonly TEAM_LEAD_ROLES: { [key: string]: { name: string, value: string }[] } = {
    [Constants.NUTRITION_COACH_TEAM_LEAD_ROLE]: [{ name: "Nutrition Coach", value: Constants.NUTRITION_COACH_ROLE }, { name: "Onboarding Coach", value: Constants.ONBOARDING_COACH_ROLE }, { name: "Nutrition Coach TL", value: Constants.NUTRITION_COACH_TEAM_LEAD_ROLE }],
    [Constants.PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE]: [{ name: "Physio Coach", value: Constants.PHYSIOTHERAPIST_COACH_ROLE }, { name: "Physio Coach TL", value: Constants.PHYSIOTHERAPIST_COACH_TEAM_LEAD_ROLE }],
    [Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE]: [{ name: "Success Coach", value: Constants.PSYCHOLOGIST_COACH_ROLE }, { name: "Success Coach TL", value: Constants.PSYCHOLOGIST_COACH_TEAM_LEAD_ROLE }],
    [Constants.CARE_MANAGER_TEAM_LEAD_ROLE]: [{ name: "MSE", value: Constants.CARE_MANAGER_ROLE }, { name: "MSE TL", value: Constants.CARE_MANAGER_TEAM_LEAD_ROLE }, { name: "Doctor", value: Constants.DOCTOR_ROLE }, { name: "Primary Operation Manager", value: Constants.PRIMARY_OPERATION_MANAGER_ROLE }],
    [Constants.ONBOARDING_AGENT_LEAD_ROLE]: [{ name: "Onboading Agent", value: Constants.ONBOARDING_AGENT_ROLE }, { name: "Onboading Agent TL", value: Constants.ONBOARDING_AGENT_LEAD_ROLE }],
    [Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE]: [{ name: "Program Advisors", value: Constants.PROGRAM_ADVISOR_ROLE }, { name: "Program Advisor TL", value: Constants.PROGRAM_ADVISOR_TEAM_LEAD_ROLE }],
  };

  public static readonly ADMIN_STATUS_ACTIVE: number = 1;
  public static readonly ADMIN_STATUS_SUSPENDED: number = 2;
  public static readonly ADMIN_STATUS_PASSWORD_CHANGE_REQUIRED: number = 3;
  public static readonly ADMIN_STATUS_INACTIVE: number = 4;
  public static readonly ADMIN_STATUS_INVITED: number = 5;

  public static readonly ADMIN_STATUS = {
    [this.ADMIN_STATUS_ACTIVE]: "Active",
    [this.ADMIN_STATUS_SUSPENDED]: "Suspended",
    [this.ADMIN_STATUS_INACTIVE]: "Inactive",
    [this.ADMIN_STATUS_INVITED]: "Invited",
    [this.ADMIN_STATUS_PASSWORD_CHANGE_REQUIRED]: "Password change required"
  };

  public static readonly INVOICE_REMARKS_OPTIONS: any = [
    {key:'OTHER', value: 'OTHER'},
    {key:'TEST', value: 'TEST'},
    {key:'SALE AND OTHER PAYMENT', value: 'SALE AND OTHER PAYMENT'},
    {key:'REFUND', value: 'REFUND'},
    {key:'REENROLLMENT', value: 'REENROLLMENT'},
    {key:'PROVIDE PROPER NUMBER TO FIND THE CASE', value: 'PROVIDE PROPER NUMBER TO FIND THE CASE'},
    {key:'SUSPENDED', value: 'SUSPENDED'},
    {key:'PAYMENT FROM OTHER NUMBER', value: 'PAYMENT FROM OTHER NUMBER'},
    {key:'PART PAYMENT CASE', value: 'PART PAYMENT CASE'},
    {key:'MULTIPLE PAYMENTS', value: 'MULTIPLE PAYMENTS'},
    {key:'LEAD NOT CONSENTED AS PER AMOUNT RECEIVED', value: 'LEAD NOT CONSENTED AS PER AMOUNT RECEIVED'},
    {key:'LEAD NOT CONSENTED', value: 'LEAD NOT CONSENTED'},
    {key:'FULL/PARTIAL PAYMENT DONE FROM OTHER NUMBER', value: 'FULL/PARTIAL PAYMENT DONE FROM OTHER NUMBER'},
    {key:'EMAIL SENT TO TECH TO RESOLVE', value: 'EMAIL SENT TO TECH TO RESOLVE'},
    {key:'DUPLICATE INVOICE', value: 'DUPLICATE INVOICE'},
    {key:'DISCOUNTED CASE', value: 'DISCOUNTED CASE'},
    {key:'CORPORATE', value: 'CORPORATE'},
    {key:'AS PER FINANCE PAYMENT NOT RECEIVED', value: 'AS PER FINANCE PAYMENT NOT RECEIVED'},
    {key:'AFTER SALE OR OTHER PAYMENT', value: 'AFTER SALE OR OTHER PAYMENT'},
    {key:'ABOUT TO VALIDATE IN FUTURE', value: 'ABOUT TO VALIDATE IN FUTURE'},
    {key:'TYPO ERROR IN PROGRAM PRICE or AMOUNT RECEIVED PRICE', value: 'TYPO ERROR IN PROGRAM PRICE or AMOUNT RECEIVED PRICE'}
  ];

  public static readonly BOOK_TASK_CALL_TYPES: {label: string, value: boolean | null}[] = [
    { label: 'All', value: null },
    { label: 'Booked', value: false },
    { label: 'Not Booked', value: true },
  ];

  public static readonly CLEVERTAP_RESPONDED_OPTIONS: {label: string, value: boolean}[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  public static readonly PACK_TYPES: any[] = [
    {
      key: 'doctor_consultation',
      name: 'Doctor Consultation',
    },
    {
      key: 'psychology_consultation',
      name: 'Psychology Consultation',
    },
    {
      key: 'fitness_consultation',
      name: 'Fitness Consultation',
    },
    {
      key: 'pain_consultation',
      name: 'Pain Consultation',
    },
    {
      key: 'nutrition_consultation',
      name: 'Nutrition Consultation',
    },
  ];

  public static readonly PACK_STATUSES: any[] = [
    {
      id: 1,
      name: 'Upcoming',
    },
    {
      id: 2,
      name: 'Completed',
    },
    {
      id: 3,
      name: 'Active',
    },
  ];

  public static readonly DOCTOR_TYPES: { [key: number]: { type_id: number, name: string } } = {
    1: {
      type_id: 1,
      name: "Attending Physician",
    },
    2: {
      type_id: 2,
      name: "Referring Doctor",
    }
  };

  public static readonly ONLY_COACHES: any[] = [
    {
      role: Constants.NUTRITION_COACH_ROLE,
      displayName: 'Nutrition Coach'
    },
    {
      role: Constants.PHYSIOTHERAPIST_COACH_ROLE,
      displayName: 'Physiotherapist'
    },
    {
      role: Constants.PSYCHOLOGIST_COACH_ROLE,
      displayName: 'Psychologist'
    },
    {
      role: Constants.CARE_MANAGER_ROLE,
      displayName: 'Care Manager'
    },
    {
      role: Constants.NUTRITION_COACH_TEAM_LEAD_ROLE,
      displayName: 'Nutrition Coach TL'
    }
  ]

  public static readonly MASTERS_MILESTONES: { id: number; name: string }[] = [
    { id: 0, name: 'All' },
    { id: 1, name: 'Milestone 1' },
    { id: 2, name: 'Milestone 2' },
    { id: 3, name: 'Milestone 3' },
    { id: 4, name: 'Milestone 4' },
    { id: 5, name: 'Milestone 5' },
  ];

  public static readonly TOTAL_TASKS: number = 100;
  public static readonly NUTRITION_ASSESSMENT_CALL_TASK_UNIQUE_KEY: string = 'pc_initial_nutritional_assessment_call';
  public static readonly ADDITIONAL_HIGH_RISK_CALL_TASK_UNIQUE_KEY: string = 'pc_high_risk_add_on_call';

  public static readonly MILESTONE_EXPIRIES: {label: string, value: string}[] = [
    {
      label: 'Today',
      value: 'today',
    },
    {
      label: '1-7 days',
      value: '1-7 days',
    },
    {
      label: '8-15 days',
      value: '8-15 days',
    },
    {
      label: '15+ days',
      value: '15+ days',
    }
  ];

  static readonly ACCESS_CUBE_DETAILS_EMAILS: string[] = [
    'anjali.daftari@fitterfly.in', 'anjali.daftari@pbhealth.com',
    'jainam.parikh@fitterfly.in', 'jainam.parikh@pbhealth.com',
    'fenil.parikh@fitterfly.in', 'fenil.parikh@pbhealth.com',
    'karan.parikh@fitterfly.in', 'karan.parikh@pbhealth.com',
    'gunvant.jambu@fitterfly.in', 'jambu.gunavant@pbhealth.com',
    'sandesh.kardekar@pbhealth.com',
  ];

  public static readonly PARTICIPATION_STATUSES_NOT_ONGOING: number[] = [Constants.PARTICIPATION_STATUS_HOLD, Constants.PARTICIPATION_STATUS_INACTIVE, Constants.PARTICIPATION_STATUS_SUSPENDED, Constants.PARTICIPATION_STATUS_COMPLETED];

  public static readonly CM_PER_INCH: number = 2.54;
  public static readonly INCHES_PER_FOOT: number = 12;
}
